/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * cnct example
 * The CNCT API description
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";

import type {
  BannerAnalysisCompleteExportJobBodyDto,
  BannerAnalysisCompleteReportBodyDto,
  BannerAnalysisControllerListReportsParams,
  BannerAnalysisCreateExportJobRequestDto,
  BannerAnalysisCreateExportJobResponseDto,
  BannerAnalysisCreateReportBodyDto,
  BannerAnalysisCreateReportErrorResponseDto,
  BannerAnalysisCreateReportResponseDto,
  BannerAnalysisCsvboxUploaderKeyResponseDto,
  BannerAnalysisDeleteReportResponseDto,
  BannerAnalysisDownloadExportResponseDto,
  BannerAnalysisExportJobCallbackResponseDto,
  BannerAnalysisFailExportJobBodyDto,
  BannerAnalysisFailReportBodyDto,
  BannerAnalysisGetExportJobResponseDto,
  BannerAnalysisGetReportResponseDto,
  BannerAnalysisListReportsResponseDto,
  BannerAnalysisRegisterImprovedBannerBodyDto,
  BannerAnalysisRegisterImprovedBannerResponseDto,
  BannerAnalysisReportDetailResponseDto,
  BannerAnalysisRequestImagesUploadBodyDto,
  BannerAnalysisRequestImagesUploadResponseDto,
  BannerAnalysisUpdateReportVisibilityBodyDto,
  BannerAnalysisUpdateReportVisibilityResponseDto,
  BannerAnalysisUploadCsvBodyDto,
  BannerAnalysisUploadCsvResponseDto,
  BannerAnalysisWorkerCallbackResponseDto,
  BannerGenerationCompleteGenerationBodyDto,
  BannerGenerationControllerGetImageParams,
  BannerGenerationControllerListImagesParams,
  BannerGenerationCreateGenerationBodyDto,
  BannerGenerationCreateGenerationErrorResponseDto,
  BannerGenerationCreateGenerationResponseDto,
  BannerGenerationDeleteImageResponseDto,
  BannerGenerationFailGenerationBodyDto,
  BannerGenerationGetImageResponseDto,
  BannerGenerationGetMediaPlaceholdersResponseDto,
  BannerGenerationGetPlaceholdersResponseDto,
  BannerGenerationJobDetailResponseDto,
  BannerGenerationListImagesResponseDto,
  BannerGenerationRegisterUploadedImageResponseDto,
  BannerGenerationRequestImageUploadBodyDto,
  BannerGenerationRequestImageUploadResponseDto,
  BannerGenerationUpdateImageBodyDto,
  BannerGenerationUpdateImageResponseDto,
  BannerGenerationUpdateImageVisibilityBodyDto,
  BannerGenerationUpdateImageVisibilityResponseDto,
  BannerGenerationUpsertPlaceholderBodyDto,
  BannerGenerationUpsertPlaceholderResponseDto,
  BannerGenerationUpsertSizePresetBodyDto,
  BannerGenerationUpsertSizePresetResponseDto,
  BannerGenerationWorkerCallbackResponseDto,
  CreditsCreditDto,
  KnowledgeLibraryControllerListKnowledgesParams,
  KnowledgeLibraryDeleteKnowledgeResponseDto,
  KnowledgeLibraryGetKnowledgeResponseDto,
  KnowledgeLibraryKnowledgeDto,
  KnowledgeLibraryListKnowledgesResponseDto,
  KnowledgeLibraryRegisterKnowledgeBodyDto,
  KnowledgeLibraryUpdateKnowledgeBodyDto,
  ReportLibraryControllerGetReportParams,
  ReportLibraryControllerListReportsParams,
  ReportLibraryDeleteReportResponseDto,
  ReportLibraryGetReportResponseDto,
  ReportLibraryListReportsResponseDto,
  ReportLibraryReportDto,
  ReportLibraryRequestReportUploadBodyDto,
  ReportLibraryRequestReportUploadResponseDto,
  ReportLibraryUpdateReportBodyDto,
  ReportLibraryUpdateReportResponseDto,
  TenantsCreateTenantBodyDto,
  TenantsListTenantsResponseDto,
  TenantsTenantDto,
  TenantsUpdateTenantBodyDto,
  UsersInviteUserBodyDto,
  UsersListUsersResponseDto,
  UsersUpdateUserRoleBodyDto,
  UsersUserDto,
  WhoamiResponseDto,
} from "./connect.schemas.ts";

import { connectCustomInstance } from "./mutator/connect-instance.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary 広告実績 CSV をアップロード
 */
export const bannerAnalysisControllerUploadCsv = (
  tenantId: string,
  bannerAnalysisUploadCsvBodyDto: BannerAnalysisUploadCsvBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisUploadCsvResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/csv`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisUploadCsvBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerUploadCsvMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerUploadCsv>>,
    TError,
    { tenantId: string; data: BannerAnalysisUploadCsvBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisControllerUploadCsv>>,
  TError,
  { tenantId: string; data: BannerAnalysisUploadCsvBodyDto },
  TContext
> => {
  const mutationKey = ["bannerAnalysisControllerUploadCsv"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerUploadCsv>>,
    { tenantId: string; data: BannerAnalysisUploadCsvBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return bannerAnalysisControllerUploadCsv(tenantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisControllerUploadCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerUploadCsv>>
>;
export type BannerAnalysisControllerUploadCsvMutationBody =
  BannerAnalysisUploadCsvBodyDto;
export type BannerAnalysisControllerUploadCsvMutationError = unknown;

/**
 * @summary 広告実績 CSV をアップロード
 */
export const useBannerAnalysisControllerUploadCsv = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisControllerUploadCsv>>,
      TError,
      { tenantId: string; data: BannerAnalysisUploadCsvBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisControllerUploadCsv>>,
  TError,
  { tenantId: string; data: BannerAnalysisUploadCsvBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisControllerUploadCsvMutationOptions(options),
    queryClient
  );
};

/**
 * @summary csvbox のアップローダーキーを取得
 */
export const bannerAnalysisControllerGetCsvboxUploaderKey = (
  tenantId: unknown,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisCsvboxUploaderKeyResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/csvbox-uploader-key`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerGetCsvboxUploaderKeyQueryKey = (
  tenantId: unknown
) => {
  return [`/tenants/${tenantId}/banner-analysis/csvbox-uploader-key`] as const;
};

export const getBannerAnalysisControllerGetCsvboxUploaderKeyQueryOptions = <
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerGetCsvboxUploaderKeyQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>>
  > = ({ signal }) =>
    bannerAnalysisControllerGetCsvboxUploaderKey(
      tenantId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerGetCsvboxUploaderKeyQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>>
  >;
export type BannerAnalysisControllerGetCsvboxUploaderKeyQueryError = unknown;

export function useBannerAnalysisControllerGetCsvboxUploaderKey<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetCsvboxUploaderKey<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetCsvboxUploaderKey<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary csvbox のアップローダーキーを取得
 */

export function useBannerAnalysisControllerGetCsvboxUploaderKey<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerAnalysisControllerGetCsvboxUploaderKeyQueryOptions(
      tenantId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary csvbox のアップローダーキーを取得
 */
export const prefetchBannerAnalysisControllerGetCsvboxUploaderKeyQuery = async <
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions =
    getBannerAnalysisControllerGetCsvboxUploaderKeyQueryOptions(
      tenantId,
      options
    );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerAnalysisControllerGetCsvboxUploaderKeySuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
    >,
    TError = unknown,
  >(
    tenantId: unknown,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBannerAnalysisControllerGetCsvboxUploaderKeyQueryKey(tenantId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>>
    > = ({ signal }) =>
      bannerAnalysisControllerGetCsvboxUploaderKey(
        tenantId,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>>,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type BannerAnalysisControllerGetCsvboxUploaderKeySuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>>
  >;
export type BannerAnalysisControllerGetCsvboxUploaderKeySuspenseQueryError =
  unknown;

export function useBannerAnalysisControllerGetCsvboxUploaderKeySuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetCsvboxUploaderKeySuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetCsvboxUploaderKeySuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary csvbox のアップローダーキーを取得
 */

export function useBannerAnalysisControllerGetCsvboxUploaderKeySuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisControllerGetCsvboxUploaderKey>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerAnalysisControllerGetCsvboxUploaderKeySuspenseQueryOptions(
      tenantId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary バナー画像 ZIP 用の署名付き URL を発行
 */
export const bannerAnalysisControllerRequestImagesUpload = (
  tenantId: string,
  bannerAnalysisRequestImagesUploadBodyDto: BannerAnalysisRequestImagesUploadBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisRequestImagesUploadResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/images/upload-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisRequestImagesUploadBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerRequestImagesUploadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerRequestImagesUpload>>,
    TError,
    { tenantId: string; data: BannerAnalysisRequestImagesUploadBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisControllerRequestImagesUpload>>,
  TError,
  { tenantId: string; data: BannerAnalysisRequestImagesUploadBodyDto },
  TContext
> => {
  const mutationKey = ["bannerAnalysisControllerRequestImagesUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerRequestImagesUpload>>,
    { tenantId: string; data: BannerAnalysisRequestImagesUploadBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return bannerAnalysisControllerRequestImagesUpload(
      tenantId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisControllerRequestImagesUploadMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisControllerRequestImagesUpload>>
  >;
export type BannerAnalysisControllerRequestImagesUploadMutationBody =
  BannerAnalysisRequestImagesUploadBodyDto;
export type BannerAnalysisControllerRequestImagesUploadMutationError = unknown;

/**
 * @summary バナー画像 ZIP 用の署名付き URL を発行
 */
export const useBannerAnalysisControllerRequestImagesUpload = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisControllerRequestImagesUpload>>,
      TError,
      { tenantId: string; data: BannerAnalysisRequestImagesUploadBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisControllerRequestImagesUpload>>,
  TError,
  { tenantId: string; data: BannerAnalysisRequestImagesUploadBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisControllerRequestImagesUploadMutationOptions(options),
    queryClient
  );
};

/**
 * @summary バナー分析レポートの作成を依頼
 */
export const bannerAnalysisControllerCreateReport = (
  tenantId: string,
  bannerAnalysisCreateReportBodyDto: BannerAnalysisCreateReportBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisCreateReportResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/reports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisCreateReportBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerCreateReportMutationOptions = <
  TError = BannerAnalysisCreateReportErrorResponseDto,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerCreateReport>>,
    TError,
    { tenantId: string; data: BannerAnalysisCreateReportBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisControllerCreateReport>>,
  TError,
  { tenantId: string; data: BannerAnalysisCreateReportBodyDto },
  TContext
> => {
  const mutationKey = ["bannerAnalysisControllerCreateReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerCreateReport>>,
    { tenantId: string; data: BannerAnalysisCreateReportBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return bannerAnalysisControllerCreateReport(tenantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisControllerCreateReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerCreateReport>>
>;
export type BannerAnalysisControllerCreateReportMutationBody =
  BannerAnalysisCreateReportBodyDto;
export type BannerAnalysisControllerCreateReportMutationError =
  BannerAnalysisCreateReportErrorResponseDto;

/**
 * @summary バナー分析レポートの作成を依頼
 */
export const useBannerAnalysisControllerCreateReport = <
  TError = BannerAnalysisCreateReportErrorResponseDto,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisControllerCreateReport>>,
      TError,
      { tenantId: string; data: BannerAnalysisCreateReportBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisControllerCreateReport>>,
  TError,
  { tenantId: string; data: BannerAnalysisCreateReportBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisControllerCreateReportMutationOptions(options),
    queryClient
  );
};

/**
 * 他人の非公開（private）レポートは含まない（host / admin にも見せない）。
 * @summary レポート一覧を取得（作成日時の新しい順）
 */
export const bannerAnalysisControllerListReports = (
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisListReportsResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/reports`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerListReportsQueryKey = (
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams
) => {
  return [
    `/tenants/${tenantId}/banner-analysis/reports`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBannerAnalysisControllerListReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerListReportsQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>
  > = ({ signal }) =>
    bannerAnalysisControllerListReports(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerListReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>
>;
export type BannerAnalysisControllerListReportsQueryError = unknown;

export function useBannerAnalysisControllerListReports<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | BannerAnalysisControllerListReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerListReports<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerListReports<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポート一覧を取得（作成日時の新しい順）
 */

export function useBannerAnalysisControllerListReports<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerAnalysisControllerListReportsQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary レポート一覧を取得（作成日時の新しい順）
 */
export const prefetchBannerAnalysisControllerListReportsQuery = async <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getBannerAnalysisControllerListReportsQueryOptions(
    tenantId,
    params,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerAnalysisControllerListReportsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerListReportsQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>
  > = ({ signal }) =>
    bannerAnalysisControllerListReports(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerListReportsSuspenseQueryResult =
  NonNullable<Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>>;
export type BannerAnalysisControllerListReportsSuspenseQueryError = unknown;

export function useBannerAnalysisControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | BannerAnalysisControllerListReportsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポート一覧を取得（作成日時の新しい順）
 */

export function useBannerAnalysisControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerAnalysisControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerAnalysisControllerListReportsSuspenseQueryOptions(
      tenantId,
      params,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 他人の非公開（private）レポートは 404（存在秘匿）。slidesUrl は作成者（isOwner: true）にのみ返す。
 * @summary レポート詳細を取得
 */
export const bannerAnalysisControllerGetReport = (
  tenantId: string,
  reportId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisGetReportResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/reports/${reportId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerGetReportQueryKey = (
  tenantId: string,
  reportId: string
) => {
  return [`/tenants/${tenantId}/banner-analysis/reports/${reportId}`] as const;
};

export const getBannerAnalysisControllerGetReportQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerGetReportQueryKey(tenantId, reportId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>
  > = ({ signal }) =>
    bannerAnalysisControllerGetReport(
      tenantId,
      reportId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      tenantId !== null &&
      tenantId !== undefined &&
      reportId !== null &&
      reportId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerGetReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>
>;
export type BannerAnalysisControllerGetReportQueryError = unknown;

export function useBannerAnalysisControllerGetReport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetReport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetReport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポート詳細を取得
 */

export function useBannerAnalysisControllerGetReport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerAnalysisControllerGetReportQueryOptions(
    tenantId,
    reportId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary レポート詳細を取得
 */
export const prefetchBannerAnalysisControllerGetReportQuery = async <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getBannerAnalysisControllerGetReportQueryOptions(
    tenantId,
    reportId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerAnalysisControllerGetReportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerGetReportQueryKey(tenantId, reportId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>
  > = ({ signal }) =>
    bannerAnalysisControllerGetReport(
      tenantId,
      reportId,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerGetReportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>
>;
export type BannerAnalysisControllerGetReportSuspenseQueryError = unknown;

export function useBannerAnalysisControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポート詳細を取得
 */

export function useBannerAnalysisControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerAnalysisControllerGetReportSuspenseQueryOptions(
    tenantId,
    reportId,
    options
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 非公開（private）は作成者のみ、共有（tenant）は作成者と host / admin が削除できる。権限が無い場合は 403（error=REPORT_DELETE_FORBIDDEN）。
 * @summary レポートを削除
 */
export const bannerAnalysisControllerDeleteReport = (
  tenantId: string,
  reportId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisDeleteReportResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/reports/${reportId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerDeleteReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerDeleteReport>>,
    TError,
    { tenantId: string; reportId: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisControllerDeleteReport>>,
  TError,
  { tenantId: string; reportId: string },
  TContext
> => {
  const mutationKey = ["bannerAnalysisControllerDeleteReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerDeleteReport>>,
    { tenantId: string; reportId: string }
  > = (props) => {
    const { tenantId, reportId } = props ?? {};

    return bannerAnalysisControllerDeleteReport(
      tenantId,
      reportId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisControllerDeleteReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerDeleteReport>>
>;

export type BannerAnalysisControllerDeleteReportMutationError = unknown;

/**
 * @summary レポートを削除
 */
export const useBannerAnalysisControllerDeleteReport = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisControllerDeleteReport>>,
      TError,
      { tenantId: string; reportId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisControllerDeleteReport>>,
  TError,
  { tenantId: string; reportId: string },
  TContext
> => {
  return useMutation(
    getBannerAnalysisControllerDeleteReportMutationOptions(options),
    queryClient
  );
};

/**
 * 共有化（tenant）は作成者のみ、共有解除（private）は作成者と host / admin が行える。権限が無い場合は 403（error=REPORT_VISIBILITY_FORBIDDEN）。
 * @summary レポートの可視性（共有 / 非公開）を変更
 */
export const bannerAnalysisControllerUpdateReportVisibility = (
  tenantId: string,
  reportId: string,
  bannerAnalysisUpdateReportVisibilityBodyDto: BannerAnalysisUpdateReportVisibilityBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisUpdateReportVisibilityResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/reports/${reportId}/visibility`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisUpdateReportVisibilityBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerUpdateReportVisibilityMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerAnalysisControllerUpdateReportVisibility>
      >,
      TError,
      {
        tenantId: string;
        reportId: string;
        data: BannerAnalysisUpdateReportVisibilityBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerUpdateReportVisibility>>,
    TError,
    {
      tenantId: string;
      reportId: string;
      data: BannerAnalysisUpdateReportVisibilityBodyDto;
    },
    TContext
  > => {
    const mutationKey = ["bannerAnalysisControllerUpdateReportVisibility"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bannerAnalysisControllerUpdateReportVisibility>
      >,
      {
        tenantId: string;
        reportId: string;
        data: BannerAnalysisUpdateReportVisibilityBodyDto;
      }
    > = (props) => {
      const { tenantId, reportId, data } = props ?? {};

      return bannerAnalysisControllerUpdateReportVisibility(
        tenantId,
        reportId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BannerAnalysisControllerUpdateReportVisibilityMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisControllerUpdateReportVisibility>>
  >;
export type BannerAnalysisControllerUpdateReportVisibilityMutationBody =
  BannerAnalysisUpdateReportVisibilityBodyDto;
export type BannerAnalysisControllerUpdateReportVisibilityMutationError =
  unknown;

/**
 * @summary レポートの可視性（共有 / 非公開）を変更
 */
export const useBannerAnalysisControllerUpdateReportVisibility = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerAnalysisControllerUpdateReportVisibility>
      >,
      TError,
      {
        tenantId: string;
        reportId: string;
        data: BannerAnalysisUpdateReportVisibilityBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisControllerUpdateReportVisibility>>,
  TError,
  {
    tenantId: string;
    reportId: string;
    data: BannerAnalysisUpdateReportVisibilityBodyDto;
  },
  TContext
> => {
  return useMutation(
    getBannerAnalysisControllerUpdateReportVisibilityMutationOptions(options),
    queryClient
  );
};

/**
 * @summary エクスポートを依頼（PDF / PPTX。succeeded のレポートのみ）
 */
export const bannerAnalysisControllerCreateExportJob = (
  tenantId: string,
  reportId: string,
  bannerAnalysisCreateExportJobRequestDto?: BannerAnalysisCreateExportJobRequestDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisCreateExportJobResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/reports/${reportId}/exports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisCreateExportJobRequestDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerCreateExportJobMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerCreateExportJob>>,
    TError,
    {
      tenantId: string;
      reportId: string;
      data?: BannerAnalysisCreateExportJobRequestDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisControllerCreateExportJob>>,
  TError,
  {
    tenantId: string;
    reportId: string;
    data?: BannerAnalysisCreateExportJobRequestDto;
  },
  TContext
> => {
  const mutationKey = ["bannerAnalysisControllerCreateExportJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerCreateExportJob>>,
    {
      tenantId: string;
      reportId: string;
      data?: BannerAnalysisCreateExportJobRequestDto;
    }
  > = (props) => {
    const { tenantId, reportId, data } = props ?? {};

    return bannerAnalysisControllerCreateExportJob(
      tenantId,
      reportId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisControllerCreateExportJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerCreateExportJob>>
>;
export type BannerAnalysisControllerCreateExportJobMutationBody =
  BannerAnalysisCreateExportJobRequestDto | undefined;
export type BannerAnalysisControllerCreateExportJobMutationError = unknown;

/**
 * @summary エクスポートを依頼（PDF / PPTX。succeeded のレポートのみ）
 */
export const useBannerAnalysisControllerCreateExportJob = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisControllerCreateExportJob>>,
      TError,
      {
        tenantId: string;
        reportId: string;
        data?: BannerAnalysisCreateExportJobRequestDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisControllerCreateExportJob>>,
  TError,
  {
    tenantId: string;
    reportId: string;
    data?: BannerAnalysisCreateExportJobRequestDto;
  },
  TContext
> => {
  return useMutation(
    getBannerAnalysisControllerCreateExportJobMutationOptions(options),
    queryClient
  );
};

/**
 * 対象レポートを閲覧できない場合は 404（存在秘匿）。
 * @summary エクスポートジョブの状態を取得
 */
export const bannerAnalysisControllerGetExportJob = (
  tenantId: string,
  jobId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisGetExportJobResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/exports/${jobId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerGetExportJobQueryKey = (
  tenantId: string,
  jobId: string
) => {
  return [`/tenants/${tenantId}/banner-analysis/exports/${jobId}`] as const;
};

export const getBannerAnalysisControllerGetExportJobQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerGetExportJobQueryKey(tenantId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>
  > = ({ signal }) =>
    bannerAnalysisControllerGetExportJob(
      tenantId,
      jobId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      tenantId !== null &&
      tenantId !== undefined &&
      jobId !== null &&
      jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerGetExportJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>
>;
export type BannerAnalysisControllerGetExportJobQueryError = unknown;

export function useBannerAnalysisControllerGetExportJob<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetExportJob<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetExportJob<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary エクスポートジョブの状態を取得
 */

export function useBannerAnalysisControllerGetExportJob<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerAnalysisControllerGetExportJobQueryOptions(
    tenantId,
    jobId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary エクスポートジョブの状態を取得
 */
export const prefetchBannerAnalysisControllerGetExportJobQuery = async <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getBannerAnalysisControllerGetExportJobQueryOptions(
    tenantId,
    jobId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerAnalysisControllerGetExportJobSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerGetExportJobQueryKey(tenantId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>
  > = ({ signal }) =>
    bannerAnalysisControllerGetExportJob(
      tenantId,
      jobId,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerGetExportJobSuspenseQueryResult =
  NonNullable<Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>>;
export type BannerAnalysisControllerGetExportJobSuspenseQueryError = unknown;

export function useBannerAnalysisControllerGetExportJobSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetExportJobSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerGetExportJobSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary エクスポートジョブの状態を取得
 */

export function useBannerAnalysisControllerGetExportJobSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerGetExportJob>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerAnalysisControllerGetExportJobSuspenseQueryOptions(
      tenantId,
      jobId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 対象レポートを閲覧できない場合は 404（存在秘匿）。
 * @summary 完了ジョブのダウンロード用署名付き URL を発行
 */
export const bannerAnalysisControllerDownloadExport = (
  tenantId: string,
  jobId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisDownloadExportResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-analysis/exports/${jobId}/download`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getBannerAnalysisControllerDownloadExportQueryKey = (
  tenantId: string,
  jobId: string
) => {
  return [
    `/tenants/${tenantId}/banner-analysis/exports/${jobId}/download`,
  ] as const;
};

export const getBannerAnalysisControllerDownloadExportQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerDownloadExportQueryKey(tenantId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>
  > = ({ signal }) =>
    bannerAnalysisControllerDownloadExport(
      tenantId,
      jobId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      tenantId !== null &&
      tenantId !== undefined &&
      jobId !== null &&
      jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerDownloadExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>
>;
export type BannerAnalysisControllerDownloadExportQueryError = unknown;

export function useBannerAnalysisControllerDownloadExport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerDownloadExport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
          TError,
          Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerDownloadExport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 完了ジョブのダウンロード用署名付き URL を発行
 */

export function useBannerAnalysisControllerDownloadExport<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerAnalysisControllerDownloadExportQueryOptions(
    tenantId,
    jobId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 完了ジョブのダウンロード用署名付き URL を発行
 */
export const prefetchBannerAnalysisControllerDownloadExportQuery = async <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getBannerAnalysisControllerDownloadExportQueryOptions(
    tenantId,
    jobId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerAnalysisControllerDownloadExportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisControllerDownloadExportQueryKey(tenantId, jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>
  > = ({ signal }) =>
    bannerAnalysisControllerDownloadExport(
      tenantId,
      jobId,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisControllerDownloadExportSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>
  >;
export type BannerAnalysisControllerDownloadExportSuspenseQueryError = unknown;

export function useBannerAnalysisControllerDownloadExportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerDownloadExportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisControllerDownloadExportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 完了ジョブのダウンロード用署名付き URL を発行
 */

export function useBannerAnalysisControllerDownloadExportSuspense<
  TData = Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
  TError = unknown,
>(
  tenantId: string,
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerAnalysisControllerDownloadExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerAnalysisControllerDownloadExportSuspenseQueryOptions(
      tenantId,
      jobId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ジョブ処理情報（分析条件・入力 URI・依頼者）を取得（worker 用）
 */
export const bannerAnalysisCallbackControllerGetReportDetail = (
  reportId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisReportDetailResponseDto>(
    {
      url: `/callback/banner-analysis/reports/${reportId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getBannerAnalysisCallbackControllerGetReportDetailQueryKey = (
  reportId: string
) => {
  return [`/callback/banner-analysis/reports/${reportId}`] as const;
};

export const getBannerAnalysisCallbackControllerGetReportDetailQueryOptions = <
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerAnalysisCallbackControllerGetReportDetailQueryKey(reportId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>>
  > = ({ signal }) =>
    bannerAnalysisCallbackControllerGetReportDetail(
      reportId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: reportId !== null && reportId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAnalysisCallbackControllerGetReportDetailQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>>
  >;
export type BannerAnalysisCallbackControllerGetReportDetailQueryError = unknown;

export function useBannerAnalysisCallbackControllerGetReportDetail<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisCallbackControllerGetReportDetail<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisCallbackControllerGetReportDetail<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ジョブ処理情報（分析条件・入力 URI・依頼者）を取得（worker 用）
 */

export function useBannerAnalysisCallbackControllerGetReportDetail<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerAnalysisCallbackControllerGetReportDetailQueryOptions(
      reportId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ジョブ処理情報（分析条件・入力 URI・依頼者）を取得（worker 用）
 */
export const prefetchBannerAnalysisCallbackControllerGetReportDetailQuery =
  async <
    TData = Awaited<
      ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
    >,
    TError = unknown,
  >(
    queryClient: QueryClient,
    reportId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ): Promise<QueryClient> => {
    const queryOptions =
      getBannerAnalysisCallbackControllerGetReportDetailQueryOptions(
        reportId,
        options
      );

    await queryClient.prefetchQuery(queryOptions);

    return queryClient;
  };

export const getBannerAnalysisCallbackControllerGetReportDetailSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
    >,
    TError = unknown,
  >(
    reportId: string,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBannerAnalysisCallbackControllerGetReportDetailQueryKey(reportId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
      >
    > = ({ signal }) =>
      bannerAnalysisCallbackControllerGetReportDetail(
        reportId,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type BannerAnalysisCallbackControllerGetReportDetailSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>>
  >;
export type BannerAnalysisCallbackControllerGetReportDetailSuspenseQueryError =
  unknown;

export function useBannerAnalysisCallbackControllerGetReportDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisCallbackControllerGetReportDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerAnalysisCallbackControllerGetReportDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ジョブ処理情報（分析条件・入力 URI・依頼者）を取得（worker 用）
 */

export function useBannerAnalysisCallbackControllerGetReportDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
  >,
  TError = unknown,
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerAnalysisCallbackControllerGetReportDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerAnalysisCallbackControllerGetReportDetailSuspenseQueryOptions(
      reportId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary レポートを処理中にする（worker コールバック）
 */
export const bannerAnalysisCallbackControllerMarkProcessing = (
  reportId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisWorkerCallbackResponseDto>(
    {
      url: `/callback/banner-analysis/reports/${reportId}/processing`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getBannerAnalysisCallbackControllerMarkProcessingMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerMarkProcessing>
      >,
      TError,
      { reportId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerMarkProcessing>>,
    TError,
    { reportId: string },
    TContext
  > => {
    const mutationKey = ["bannerAnalysisCallbackControllerMarkProcessing"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerMarkProcessing>
      >,
      { reportId: string }
    > = (props) => {
      const { reportId } = props ?? {};

      return bannerAnalysisCallbackControllerMarkProcessing(
        reportId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BannerAnalysisCallbackControllerMarkProcessingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerMarkProcessing>>
  >;

export type BannerAnalysisCallbackControllerMarkProcessingMutationError = void;

/**
 * @summary レポートを処理中にする（worker コールバック）
 */
export const useBannerAnalysisCallbackControllerMarkProcessing = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerMarkProcessing>
      >,
      TError,
      { reportId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerMarkProcessing>>,
  TError,
  { reportId: string },
  TContext
> => {
  return useMutation(
    getBannerAnalysisCallbackControllerMarkProcessingMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 改善バナーを画像ライブラリへ登録する（worker コールバック）
 */
export const bannerAnalysisCallbackControllerRegisterImprovedBanner = (
  reportId: string,
  bannerAnalysisRegisterImprovedBannerBodyDto: BannerAnalysisRegisterImprovedBannerBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisRegisterImprovedBannerResponseDto>(
    {
      url: `/callback/banner-analysis/reports/${reportId}/improved-banners`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisRegisterImprovedBannerBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisCallbackControllerRegisterImprovedBannerMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bannerAnalysisCallbackControllerRegisterImprovedBanner
        >
      >,
      TError,
      { reportId: string; data: BannerAnalysisRegisterImprovedBannerBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bannerAnalysisCallbackControllerRegisterImprovedBanner>
    >,
    TError,
    { reportId: string; data: BannerAnalysisRegisterImprovedBannerBodyDto },
    TContext
  > => {
    const mutationKey = [
      "bannerAnalysisCallbackControllerRegisterImprovedBanner",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bannerAnalysisCallbackControllerRegisterImprovedBanner
        >
      >,
      { reportId: string; data: BannerAnalysisRegisterImprovedBannerBodyDto }
    > = (props) => {
      const { reportId, data } = props ?? {};

      return bannerAnalysisCallbackControllerRegisterImprovedBanner(
        reportId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BannerAnalysisCallbackControllerRegisterImprovedBannerMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bannerAnalysisCallbackControllerRegisterImprovedBanner>
    >
  >;
export type BannerAnalysisCallbackControllerRegisterImprovedBannerMutationBody =
  BannerAnalysisRegisterImprovedBannerBodyDto;
export type BannerAnalysisCallbackControllerRegisterImprovedBannerMutationError =
  unknown;

/**
 * @summary 改善バナーを画像ライブラリへ登録する（worker コールバック）
 */
export const useBannerAnalysisCallbackControllerRegisterImprovedBanner = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bannerAnalysisCallbackControllerRegisterImprovedBanner
        >
      >,
      TError,
      { reportId: string; data: BannerAnalysisRegisterImprovedBannerBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof bannerAnalysisCallbackControllerRegisterImprovedBanner>
  >,
  TError,
  { reportId: string; data: BannerAnalysisRegisterImprovedBannerBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisCallbackControllerRegisterImprovedBannerMutationOptions(
      options
    ),
    queryClient
  );
};

/**
 * @summary 分析成功を確定する（worker コールバック）
 */
export const bannerAnalysisCallbackControllerComplete = (
  reportId: string,
  bannerAnalysisCompleteReportBodyDto: BannerAnalysisCompleteReportBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisWorkerCallbackResponseDto>(
    {
      url: `/callback/banner-analysis/reports/${reportId}/complete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisCompleteReportBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisCallbackControllerCompleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerComplete>>,
    TError,
    { reportId: string; data: BannerAnalysisCompleteReportBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerComplete>>,
  TError,
  { reportId: string; data: BannerAnalysisCompleteReportBodyDto },
  TContext
> => {
  const mutationKey = ["bannerAnalysisCallbackControllerComplete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerComplete>>,
    { reportId: string; data: BannerAnalysisCompleteReportBodyDto }
  > = (props) => {
    const { reportId, data } = props ?? {};

    return bannerAnalysisCallbackControllerComplete(
      reportId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisCallbackControllerCompleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerComplete>>
  >;
export type BannerAnalysisCallbackControllerCompleteMutationBody =
  BannerAnalysisCompleteReportBodyDto;
export type BannerAnalysisCallbackControllerCompleteMutationError = unknown;

/**
 * @summary 分析成功を確定する（worker コールバック）
 */
export const useBannerAnalysisCallbackControllerComplete = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisCallbackControllerComplete>>,
      TError,
      { reportId: string; data: BannerAnalysisCompleteReportBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerComplete>>,
  TError,
  { reportId: string; data: BannerAnalysisCompleteReportBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisCallbackControllerCompleteMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 分析失敗を確定する（worker コールバック）
 */
export const bannerAnalysisCallbackControllerFail = (
  reportId: string,
  bannerAnalysisFailReportBodyDto: BannerAnalysisFailReportBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisWorkerCallbackResponseDto>(
    {
      url: `/callback/banner-analysis/reports/${reportId}/fail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisFailReportBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisCallbackControllerFailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFail>>,
    TError,
    { reportId: string; data: BannerAnalysisFailReportBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFail>>,
  TError,
  { reportId: string; data: BannerAnalysisFailReportBodyDto },
  TContext
> => {
  const mutationKey = ["bannerAnalysisCallbackControllerFail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFail>>,
    { reportId: string; data: BannerAnalysisFailReportBodyDto }
  > = (props) => {
    const { reportId, data } = props ?? {};

    return bannerAnalysisCallbackControllerFail(reportId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisCallbackControllerFailMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFail>>
>;
export type BannerAnalysisCallbackControllerFailMutationBody =
  BannerAnalysisFailReportBodyDto;
export type BannerAnalysisCallbackControllerFailMutationError = unknown;

/**
 * @summary 分析失敗を確定する（worker コールバック）
 */
export const useBannerAnalysisCallbackControllerFail = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFail>>,
      TError,
      { reportId: string; data: BannerAnalysisFailReportBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFail>>,
  TError,
  { reportId: string; data: BannerAnalysisFailReportBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisCallbackControllerFailMutationOptions(options),
    queryClient
  );
};

/**
 * @summary エクスポート成功を確定する（worker コールバック）
 */
export const bannerAnalysisCallbackControllerCompleteExportJob = (
  jobId: string,
  bannerAnalysisCompleteExportJobBodyDto: BannerAnalysisCompleteExportJobBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisExportJobCallbackResponseDto>(
    {
      url: `/callback/banner-analysis/exports/${jobId}/complete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisCompleteExportJobBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisCallbackControllerCompleteExportJobMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerCompleteExportJob>
      >,
      TError,
      { jobId: string; data: BannerAnalysisCompleteExportJobBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bannerAnalysisCallbackControllerCompleteExportJob>
    >,
    TError,
    { jobId: string; data: BannerAnalysisCompleteExportJobBodyDto },
    TContext
  > => {
    const mutationKey = ["bannerAnalysisCallbackControllerCompleteExportJob"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerCompleteExportJob>
      >,
      { jobId: string; data: BannerAnalysisCompleteExportJobBodyDto }
    > = (props) => {
      const { jobId, data } = props ?? {};

      return bannerAnalysisCallbackControllerCompleteExportJob(
        jobId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BannerAnalysisCallbackControllerCompleteExportJobMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bannerAnalysisCallbackControllerCompleteExportJob>
    >
  >;
export type BannerAnalysisCallbackControllerCompleteExportJobMutationBody =
  BannerAnalysisCompleteExportJobBodyDto;
export type BannerAnalysisCallbackControllerCompleteExportJobMutationError =
  unknown;

/**
 * @summary エクスポート成功を確定する（worker コールバック）
 */
export const useBannerAnalysisCallbackControllerCompleteExportJob = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerAnalysisCallbackControllerCompleteExportJob>
      >,
      TError,
      { jobId: string; data: BannerAnalysisCompleteExportJobBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerCompleteExportJob>>,
  TError,
  { jobId: string; data: BannerAnalysisCompleteExportJobBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisCallbackControllerCompleteExportJobMutationOptions(
      options
    ),
    queryClient
  );
};

/**
 * @summary エクスポート失敗を確定する（worker コールバック）
 */
export const bannerAnalysisCallbackControllerFailExportJob = (
  jobId: string,
  bannerAnalysisFailExportJobBodyDto: BannerAnalysisFailExportJobBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerAnalysisExportJobCallbackResponseDto>(
    {
      url: `/callback/banner-analysis/exports/${jobId}/fail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerAnalysisFailExportJobBodyDto,
      signal,
    },
    options
  );
};

export const getBannerAnalysisCallbackControllerFailExportJobMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFailExportJob>>,
    TError,
    { jobId: string; data: BannerAnalysisFailExportJobBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFailExportJob>>,
  TError,
  { jobId: string; data: BannerAnalysisFailExportJobBodyDto },
  TContext
> => {
  const mutationKey = ["bannerAnalysisCallbackControllerFailExportJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFailExportJob>>,
    { jobId: string; data: BannerAnalysisFailExportJobBodyDto }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return bannerAnalysisCallbackControllerFailExportJob(
      jobId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAnalysisCallbackControllerFailExportJobMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFailExportJob>>
  >;
export type BannerAnalysisCallbackControllerFailExportJobMutationBody =
  BannerAnalysisFailExportJobBodyDto;
export type BannerAnalysisCallbackControllerFailExportJobMutationError =
  unknown;

/**
 * @summary エクスポート失敗を確定する（worker コールバック）
 */
export const useBannerAnalysisCallbackControllerFailExportJob = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFailExportJob>>,
      TError,
      { jobId: string; data: BannerAnalysisFailExportJobBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerAnalysisCallbackControllerFailExportJob>>,
  TError,
  { jobId: string; data: BannerAnalysisFailExportJobBodyDto },
  TContext
> => {
  return useMutation(
    getBannerAnalysisCallbackControllerFailExportJobMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 当月の残クレジットを取得（テナントの全ユーザー）
 */
export const creditsControllerGetCurrentCredit = (
  tenantId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<CreditsCreditDto>(
    { url: `/tenants/${tenantId}/credits`, method: "GET", signal },
    options
  );
};

export const getCreditsControllerGetCurrentCreditQueryKey = (
  tenantId: string
) => {
  return [`/tenants/${tenantId}/credits`] as const;
};

export const getCreditsControllerGetCurrentCreditQueryOptions = <
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreditsControllerGetCurrentCreditQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>
  > = ({ signal }) =>
    creditsControllerGetCurrentCredit(tenantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreditsControllerGetCurrentCreditQueryResult = NonNullable<
  Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>
>;
export type CreditsControllerGetCurrentCreditQueryError = unknown;

export function useCreditsControllerGetCurrentCredit<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
          TError,
          Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreditsControllerGetCurrentCredit<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
          TError,
          Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreditsControllerGetCurrentCredit<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 当月の残クレジットを取得（テナントの全ユーザー）
 */

export function useCreditsControllerGetCurrentCredit<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCreditsControllerGetCurrentCreditQueryOptions(
    tenantId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 当月の残クレジットを取得（テナントの全ユーザー）
 */
export const prefetchCreditsControllerGetCurrentCreditQuery = async <
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getCreditsControllerGetCurrentCreditQueryOptions(
    tenantId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getCreditsControllerGetCurrentCreditSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreditsControllerGetCurrentCreditQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>
  > = ({ signal }) =>
    creditsControllerGetCurrentCredit(tenantId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreditsControllerGetCurrentCreditSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>
>;
export type CreditsControllerGetCurrentCreditSuspenseQueryError = unknown;

export function useCreditsControllerGetCurrentCreditSuspense<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreditsControllerGetCurrentCreditSuspense<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCreditsControllerGetCurrentCreditSuspense<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 当月の残クレジットを取得（テナントの全ユーザー）
 */

export function useCreditsControllerGetCurrentCreditSuspense<
  TData = Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof creditsControllerGetCurrentCredit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCreditsControllerGetCurrentCreditSuspenseQueryOptions(
    tenantId,
    options
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * CloudFront は署名の無いリクエストを 403 で拒む。テナントのパス配下だけを許可するため、ホストがテナントを切り替えたら発行し直す。
 * @summary サムネイル閲覧の Cookie を発行（全ロール）
 */
export const thumbnailControllerIssueCookie = (
  tenantId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<void>(
    { url: `/tenants/${tenantId}/thumbnail-access`, method: "POST", signal },
    options
  );
};

export const getThumbnailControllerIssueCookieMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof thumbnailControllerIssueCookie>>,
    TError,
    { tenantId: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof thumbnailControllerIssueCookie>>,
  TError,
  { tenantId: string },
  TContext
> => {
  const mutationKey = ["thumbnailControllerIssueCookie"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof thumbnailControllerIssueCookie>>,
    { tenantId: string }
  > = (props) => {
    const { tenantId } = props ?? {};

    return thumbnailControllerIssueCookie(tenantId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ThumbnailControllerIssueCookieMutationResult = NonNullable<
  Awaited<ReturnType<typeof thumbnailControllerIssueCookie>>
>;

export type ThumbnailControllerIssueCookieMutationError = unknown;

/**
 * @summary サムネイル閲覧の Cookie を発行（全ロール）
 */
export const useThumbnailControllerIssueCookie = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof thumbnailControllerIssueCookie>>,
      TError,
      { tenantId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof thumbnailControllerIssueCookie>>,
  TError,
  { tenantId: string },
  TContext
> => {
  return useMutation(
    getThumbnailControllerIssueCookieMutationOptions(options),
    queryClient
  );
};

/**
 * @summary バナー生成を依頼（新規/改善）
 */
export const bannerGenerationControllerCreateGeneration = (
  tenantId: string,
  bannerGenerationCreateGenerationBodyDto: BannerGenerationCreateGenerationBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationCreateGenerationResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/generations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationCreateGenerationBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerCreateGenerationMutationOptions = <
  TError = BannerGenerationCreateGenerationErrorResponseDto,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerCreateGeneration>>,
    TError,
    { tenantId: string; data: BannerGenerationCreateGenerationBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerCreateGeneration>>,
  TError,
  { tenantId: string; data: BannerGenerationCreateGenerationBodyDto },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerCreateGeneration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerCreateGeneration>>,
    { tenantId: string; data: BannerGenerationCreateGenerationBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return bannerGenerationControllerCreateGeneration(
      tenantId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerCreateGenerationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerCreateGeneration>>
  >;
export type BannerGenerationControllerCreateGenerationMutationBody =
  BannerGenerationCreateGenerationBodyDto;
export type BannerGenerationControllerCreateGenerationMutationError =
  BannerGenerationCreateGenerationErrorResponseDto;

/**
 * @summary バナー生成を依頼（新規/改善）
 */
export const useBannerGenerationControllerCreateGeneration = <
  TError = BannerGenerationCreateGenerationErrorResponseDto,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerCreateGeneration>>,
      TError,
      { tenantId: string; data: BannerGenerationCreateGenerationBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerCreateGeneration>>,
  TError,
  { tenantId: string; data: BannerGenerationCreateGenerationBodyDto },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerCreateGenerationMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 画像アップロード用署名付きURLを発行
 */
export const bannerGenerationControllerRequestImageUpload = (
  tenantId: string,
  bannerGenerationRequestImageUploadBodyDto: BannerGenerationRequestImageUploadBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationRequestImageUploadResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/images/upload-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationRequestImageUploadBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerRequestImageUploadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerRequestImageUpload>>,
    TError,
    { tenantId: string; data: BannerGenerationRequestImageUploadBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerRequestImageUpload>>,
  TError,
  { tenantId: string; data: BannerGenerationRequestImageUploadBodyDto },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerRequestImageUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerRequestImageUpload>>,
    { tenantId: string; data: BannerGenerationRequestImageUploadBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return bannerGenerationControllerRequestImageUpload(
      tenantId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerRequestImageUploadMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerRequestImageUpload>>
  >;
export type BannerGenerationControllerRequestImageUploadMutationBody =
  BannerGenerationRequestImageUploadBodyDto;
export type BannerGenerationControllerRequestImageUploadMutationError = unknown;

/**
 * @summary 画像アップロード用署名付きURLを発行
 */
export const useBannerGenerationControllerRequestImageUpload = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerRequestImageUpload>>,
      TError,
      { tenantId: string; data: BannerGenerationRequestImageUploadBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerRequestImageUpload>>,
  TError,
  { tenantId: string; data: BannerGenerationRequestImageUploadBodyDto },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerRequestImageUploadMutationOptions(options),
    queryClient
  );
};

/**
 * @summary アップロード完了を登録
 */
export const bannerGenerationControllerRegisterUploadedImage = (
  tenantId: string,
  imageId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationRegisterUploadedImageResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/images/${imageId}/register`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerRegisterUploadedImageMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerGenerationControllerRegisterUploadedImage>
      >,
      TError,
      { tenantId: string; imageId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerRegisterUploadedImage>>,
    TError,
    { tenantId: string; imageId: string },
    TContext
  > => {
    const mutationKey = ["bannerGenerationControllerRegisterUploadedImage"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bannerGenerationControllerRegisterUploadedImage>
      >,
      { tenantId: string; imageId: string }
    > = (props) => {
      const { tenantId, imageId } = props ?? {};

      return bannerGenerationControllerRegisterUploadedImage(
        tenantId,
        imageId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BannerGenerationControllerRegisterUploadedImageMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerRegisterUploadedImage>>
  >;

export type BannerGenerationControllerRegisterUploadedImageMutationError =
  unknown;

/**
 * @summary アップロード完了を登録
 */
export const useBannerGenerationControllerRegisterUploadedImage = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerGenerationControllerRegisterUploadedImage>
      >,
      TError,
      { tenantId: string; imageId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerRegisterUploadedImage>>,
  TError,
  { tenantId: string; imageId: string },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerRegisterUploadedImageMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 全社共通プレースホルダ一覧を取得（ホスト限定）
 */
export const bannerGenerationControllerGetPlaceholders = (
  tenantId: unknown,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationGetPlaceholdersResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/placeholders`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerGetPlaceholdersQueryKey = (
  tenantId: unknown
) => {
  return [`/tenants/${tenantId}/banner-generation/placeholders`] as const;
};

export const getBannerGenerationControllerGetPlaceholdersQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerGenerationControllerGetPlaceholdersQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>
  > = ({ signal }) =>
    bannerGenerationControllerGetPlaceholders(tenantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerGenerationControllerGetPlaceholdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>
>;
export type BannerGenerationControllerGetPlaceholdersQueryError = unknown;

export function useBannerGenerationControllerGetPlaceholders<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
          TError,
          Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetPlaceholders<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
          TError,
          Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetPlaceholders<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 全社共通プレースホルダ一覧を取得（ホスト限定）
 */

export function useBannerGenerationControllerGetPlaceholders<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerGenerationControllerGetPlaceholdersQueryOptions(
    tenantId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 全社共通プレースホルダ一覧を取得（ホスト限定）
 */
export const prefetchBannerGenerationControllerGetPlaceholdersQuery = async <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getBannerGenerationControllerGetPlaceholdersQueryOptions(
    tenantId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerGenerationControllerGetPlaceholdersSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof bannerGenerationControllerGetPlaceholders>
    >,
    TError = unknown,
  >(
    tenantId: unknown,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBannerGenerationControllerGetPlaceholdersQueryKey(tenantId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>
    > = ({ signal }) =>
      bannerGenerationControllerGetPlaceholders(
        tenantId,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type BannerGenerationControllerGetPlaceholdersSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>
  >;
export type BannerGenerationControllerGetPlaceholdersSuspenseQueryError =
  unknown;

export function useBannerGenerationControllerGetPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 全社共通プレースホルダ一覧を取得（ホスト限定）
 */

export function useBannerGenerationControllerGetPlaceholdersSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetPlaceholders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerGenerationControllerGetPlaceholdersSuspenseQueryOptions(
      tenantId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * メディア表示名を設定したプレースホルダのキーと表示名を返す。補完テキストは含めない。
 * @summary メディア一覧を取得（全ロール）
 */
export const bannerGenerationControllerGetMediaPlaceholders = (
  tenantId: unknown,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationGetMediaPlaceholdersResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/media-placeholders`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerGetMediaPlaceholdersQueryKey = (
  tenantId: unknown
) => {
  return [`/tenants/${tenantId}/banner-generation/media-placeholders`] as const;
};

export const getBannerGenerationControllerGetMediaPlaceholdersQueryOptions = <
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerGenerationControllerGetMediaPlaceholdersQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>>
  > = ({ signal }) =>
    bannerGenerationControllerGetMediaPlaceholders(
      tenantId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerGenerationControllerGetMediaPlaceholdersQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>>
  >;
export type BannerGenerationControllerGetMediaPlaceholdersQueryError = unknown;

export function useBannerGenerationControllerGetMediaPlaceholders<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetMediaPlaceholders<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetMediaPlaceholders<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary メディア一覧を取得（全ロール）
 */

export function useBannerGenerationControllerGetMediaPlaceholders<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerGenerationControllerGetMediaPlaceholdersQueryOptions(
      tenantId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary メディア一覧を取得（全ロール）
 */
export const prefetchBannerGenerationControllerGetMediaPlaceholdersQuery =
  async <
    TData = Awaited<
      ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
    >,
    TError = unknown,
  >(
    queryClient: QueryClient,
    tenantId: unknown,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ): Promise<QueryClient> => {
    const queryOptions =
      getBannerGenerationControllerGetMediaPlaceholdersQueryOptions(
        tenantId,
        options
      );

    await queryClient.prefetchQuery(queryOptions);

    return queryClient;
  };

export const getBannerGenerationControllerGetMediaPlaceholdersSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
    >,
    TError = unknown,
  >(
    tenantId: unknown,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBannerGenerationControllerGetMediaPlaceholdersQueryKey(tenantId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>>
    > = ({ signal }) =>
      bannerGenerationControllerGetMediaPlaceholders(
        tenantId,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type BannerGenerationControllerGetMediaPlaceholdersSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>>
  >;
export type BannerGenerationControllerGetMediaPlaceholdersSuspenseQueryError =
  unknown;

export function useBannerGenerationControllerGetMediaPlaceholdersSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetMediaPlaceholdersSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetMediaPlaceholdersSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary メディア一覧を取得（全ロール）
 */

export function useBannerGenerationControllerGetMediaPlaceholdersSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
  >,
  TError = unknown,
>(
  tenantId: unknown,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationControllerGetMediaPlaceholders>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerGenerationControllerGetMediaPlaceholdersSuspenseQueryOptions(
      tenantId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 全社共通プレースホルダを登録・更新（ホスト限定）
 */
export const bannerGenerationControllerUpsertPlaceholder = (
  tenantId: unknown,
  key: string,
  bannerGenerationUpsertPlaceholderBodyDto: BannerGenerationUpsertPlaceholderBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationUpsertPlaceholderResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/placeholders/${key}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationUpsertPlaceholderBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerUpsertPlaceholderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerUpsertPlaceholder>>,
    TError,
    {
      tenantId: unknown;
      key: string;
      data: BannerGenerationUpsertPlaceholderBodyDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerUpsertPlaceholder>>,
  TError,
  {
    tenantId: unknown;
    key: string;
    data: BannerGenerationUpsertPlaceholderBodyDto;
  },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerUpsertPlaceholder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerUpsertPlaceholder>>,
    {
      tenantId: unknown;
      key: string;
      data: BannerGenerationUpsertPlaceholderBodyDto;
    }
  > = (props) => {
    const { tenantId, key, data } = props ?? {};

    return bannerGenerationControllerUpsertPlaceholder(
      tenantId,
      key,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerUpsertPlaceholderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerUpsertPlaceholder>>
  >;
export type BannerGenerationControllerUpsertPlaceholderMutationBody =
  BannerGenerationUpsertPlaceholderBodyDto;
export type BannerGenerationControllerUpsertPlaceholderMutationError = unknown;

/**
 * @summary 全社共通プレースホルダを登録・更新（ホスト限定）
 */
export const useBannerGenerationControllerUpsertPlaceholder = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerUpsertPlaceholder>>,
      TError,
      {
        tenantId: unknown;
        key: string;
        data: BannerGenerationUpsertPlaceholderBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerUpsertPlaceholder>>,
  TError,
  {
    tenantId: unknown;
    key: string;
    data: BannerGenerationUpsertPlaceholderBodyDto;
  },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerUpsertPlaceholderMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 全社共通プレースホルダを削除（ホスト限定）
 */
export const bannerGenerationControllerDeletePlaceholder = (
  tenantId: unknown,
  key: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<void>(
    {
      url: `/tenants/${tenantId}/banner-generation/placeholders/${key}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerDeletePlaceholderMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerDeletePlaceholder>>,
    TError,
    { tenantId: unknown; key: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerDeletePlaceholder>>,
  TError,
  { tenantId: unknown; key: string },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerDeletePlaceholder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerDeletePlaceholder>>,
    { tenantId: unknown; key: string }
  > = (props) => {
    const { tenantId, key } = props ?? {};

    return bannerGenerationControllerDeletePlaceholder(
      tenantId,
      key,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerDeletePlaceholderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerDeletePlaceholder>>
  >;

export type BannerGenerationControllerDeletePlaceholderMutationError = void;

/**
 * @summary 全社共通プレースホルダを削除（ホスト限定）
 */
export const useBannerGenerationControllerDeletePlaceholder = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerDeletePlaceholder>>,
      TError,
      { tenantId: unknown; key: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerDeletePlaceholder>>,
  TError,
  { tenantId: unknown; key: string },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerDeletePlaceholderMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 媒体のサイズプリセットを登録・更新（ホスト限定）
 */
export const bannerGenerationControllerUpsertSizePreset = (
  tenantId: unknown,
  key: string,
  presetId: string,
  bannerGenerationUpsertSizePresetBodyDto: BannerGenerationUpsertSizePresetBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationUpsertSizePresetResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/placeholders/${key}/size-presets/${presetId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationUpsertSizePresetBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerUpsertSizePresetMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerUpsertSizePreset>>,
    TError,
    {
      tenantId: unknown;
      key: string;
      presetId: string;
      data: BannerGenerationUpsertSizePresetBodyDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerUpsertSizePreset>>,
  TError,
  {
    tenantId: unknown;
    key: string;
    presetId: string;
    data: BannerGenerationUpsertSizePresetBodyDto;
  },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerUpsertSizePreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerUpsertSizePreset>>,
    {
      tenantId: unknown;
      key: string;
      presetId: string;
      data: BannerGenerationUpsertSizePresetBodyDto;
    }
  > = (props) => {
    const { tenantId, key, presetId, data } = props ?? {};

    return bannerGenerationControllerUpsertSizePreset(
      tenantId,
      key,
      presetId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerUpsertSizePresetMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerUpsertSizePreset>>
  >;
export type BannerGenerationControllerUpsertSizePresetMutationBody =
  BannerGenerationUpsertSizePresetBodyDto;
export type BannerGenerationControllerUpsertSizePresetMutationError = void;

/**
 * @summary 媒体のサイズプリセットを登録・更新（ホスト限定）
 */
export const useBannerGenerationControllerUpsertSizePreset = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerUpsertSizePreset>>,
      TError,
      {
        tenantId: unknown;
        key: string;
        presetId: string;
        data: BannerGenerationUpsertSizePresetBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerUpsertSizePreset>>,
  TError,
  {
    tenantId: unknown;
    key: string;
    presetId: string;
    data: BannerGenerationUpsertSizePresetBodyDto;
  },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerUpsertSizePresetMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 媒体のサイズプリセットを削除（ホスト限定）
 */
export const bannerGenerationControllerDeleteSizePreset = (
  tenantId: unknown,
  key: string,
  presetId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<void>(
    {
      url: `/tenants/${tenantId}/banner-generation/placeholders/${key}/size-presets/${presetId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerDeleteSizePresetMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerDeleteSizePreset>>,
    TError,
    { tenantId: unknown; key: string; presetId: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerDeleteSizePreset>>,
  TError,
  { tenantId: unknown; key: string; presetId: string },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerDeleteSizePreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerDeleteSizePreset>>,
    { tenantId: unknown; key: string; presetId: string }
  > = (props) => {
    const { tenantId, key, presetId } = props ?? {};

    return bannerGenerationControllerDeleteSizePreset(
      tenantId,
      key,
      presetId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerDeleteSizePresetMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerDeleteSizePreset>>
  >;

export type BannerGenerationControllerDeleteSizePresetMutationError = void;

/**
 * @summary 媒体のサイズプリセットを削除（ホスト限定）
 */
export const useBannerGenerationControllerDeleteSizePreset = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerDeleteSizePreset>>,
      TError,
      { tenantId: unknown; key: string; presetId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerDeleteSizePreset>>,
  TError,
  { tenantId: unknown; key: string; presetId: string },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerDeleteSizePresetMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 画像ライブラリの一覧・検索（自分の画像と共有画像のみ）
 */
export const bannerGenerationControllerListImages = (
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationListImagesResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/images`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerListImagesQueryKey = (
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams
) => {
  return [
    `/tenants/${tenantId}/banner-generation/images`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBannerGenerationControllerListImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerGenerationControllerListImagesQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerListImages>>
  > = ({ signal }) =>
    bannerGenerationControllerListImages(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerGenerationControllerListImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerGenerationControllerListImages>>
>;
export type BannerGenerationControllerListImagesQueryError = unknown;

export function useBannerGenerationControllerListImages<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | BannerGenerationControllerListImagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
          TError,
          Awaited<ReturnType<typeof bannerGenerationControllerListImages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerListImages<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
          TError,
          Awaited<ReturnType<typeof bannerGenerationControllerListImages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerListImages<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 画像ライブラリの一覧・検索（自分の画像と共有画像のみ）
 */

export function useBannerGenerationControllerListImages<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerGenerationControllerListImagesQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 画像ライブラリの一覧・検索（自分の画像と共有画像のみ）
 */
export const prefetchBannerGenerationControllerListImagesQuery = async <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getBannerGenerationControllerListImagesQueryOptions(
    tenantId,
    params,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerGenerationControllerListImagesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerGenerationControllerListImagesQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerListImages>>
  > = ({ signal }) =>
    bannerGenerationControllerListImages(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerGenerationControllerListImagesSuspenseQueryResult =
  NonNullable<Awaited<ReturnType<typeof bannerGenerationControllerListImages>>>;
export type BannerGenerationControllerListImagesSuspenseQueryError = unknown;

export function useBannerGenerationControllerListImagesSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | BannerGenerationControllerListImagesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerListImagesSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerListImagesSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 画像ライブラリの一覧・検索（自分の画像と共有画像のみ）
 */

export function useBannerGenerationControllerListImagesSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
  TError = unknown,
>(
  tenantId: string,
  params?: BannerGenerationControllerListImagesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerListImages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerGenerationControllerListImagesSuspenseQueryOptions(
      tenantId,
      params,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 画像の状況・参照URLを取得
 */
export const bannerGenerationControllerGetImage = (
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationGetImageResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/images/${imageId}`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerGetImageQueryKey = (
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams
) => {
  return [
    `/tenants/${tenantId}/banner-generation/images/${imageId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBannerGenerationControllerGetImageQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerGenerationControllerGetImageQueryKey(tenantId, imageId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>
  > = ({ signal }) =>
    bannerGenerationControllerGetImage(
      tenantId,
      imageId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      tenantId !== null &&
      tenantId !== undefined &&
      imageId !== null &&
      imageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerGenerationControllerGetImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>
>;
export type BannerGenerationControllerGetImageQueryError = unknown;

export function useBannerGenerationControllerGetImage<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params: undefined | BannerGenerationControllerGetImageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
          TError,
          Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetImage<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
          TError,
          Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetImage<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 画像の状況・参照URLを取得
 */

export function useBannerGenerationControllerGetImage<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBannerGenerationControllerGetImageQueryOptions(
    tenantId,
    imageId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 画像の状況・参照URLを取得
 */
export const prefetchBannerGenerationControllerGetImageQuery = async <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getBannerGenerationControllerGetImageQueryOptions(
    tenantId,
    imageId,
    params,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getBannerGenerationControllerGetImageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerGenerationControllerGetImageQueryKey(tenantId, imageId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>
  > = ({ signal }) =>
    bannerGenerationControllerGetImage(
      tenantId,
      imageId,
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerGenerationControllerGetImageSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>
>;
export type BannerGenerationControllerGetImageSuspenseQueryError = unknown;

export function useBannerGenerationControllerGetImageSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params: undefined | BannerGenerationControllerGetImageParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetImageSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationControllerGetImageSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 画像の状況・参照URLを取得
 */

export function useBannerGenerationControllerGetImageSuspense<
  TData = Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
  TError = unknown,
>(
  tenantId: string,
  imageId: string,
  params?: BannerGenerationControllerGetImageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof bannerGenerationControllerGetImage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerGenerationControllerGetImageSuspenseQueryOptions(
      tenantId,
      imageId,
      params,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 画像ライブラリから画像を削除（共有画像は所有者と host / admin のみ）
 */
export const bannerGenerationControllerDeleteImage = (
  tenantId: string,
  imageId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationDeleteImageResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/images/${imageId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerDeleteImageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerDeleteImage>>,
    TError,
    { tenantId: string; imageId: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerDeleteImage>>,
  TError,
  { tenantId: string; imageId: string },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerDeleteImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerDeleteImage>>,
    { tenantId: string; imageId: string }
  > = (props) => {
    const { tenantId, imageId } = props ?? {};

    return bannerGenerationControllerDeleteImage(
      tenantId,
      imageId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerDeleteImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerGenerationControllerDeleteImage>>
>;

export type BannerGenerationControllerDeleteImageMutationError = unknown;

/**
 * @summary 画像ライブラリから画像を削除（共有画像は所有者と host / admin のみ）
 */
export const useBannerGenerationControllerDeleteImage = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerDeleteImage>>,
      TError,
      { tenantId: string; imageId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerDeleteImage>>,
  TError,
  { tenantId: string; imageId: string },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerDeleteImageMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 画像の名前・説明を更新（共有画像は所有者と host / admin のみ）
 */
export const bannerGenerationControllerUpdateImage = (
  tenantId: string,
  imageId: string,
  bannerGenerationUpdateImageBodyDto: BannerGenerationUpdateImageBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationUpdateImageResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/images/${imageId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationUpdateImageBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerUpdateImageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerUpdateImage>>,
    TError,
    {
      tenantId: string;
      imageId: string;
      data: BannerGenerationUpdateImageBodyDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationControllerUpdateImage>>,
  TError,
  {
    tenantId: string;
    imageId: string;
    data: BannerGenerationUpdateImageBodyDto;
  },
  TContext
> => {
  const mutationKey = ["bannerGenerationControllerUpdateImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationControllerUpdateImage>>,
    {
      tenantId: string;
      imageId: string;
      data: BannerGenerationUpdateImageBodyDto;
    }
  > = (props) => {
    const { tenantId, imageId, data } = props ?? {};

    return bannerGenerationControllerUpdateImage(
      tenantId,
      imageId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationControllerUpdateImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerGenerationControllerUpdateImage>>
>;
export type BannerGenerationControllerUpdateImageMutationBody =
  BannerGenerationUpdateImageBodyDto;
export type BannerGenerationControllerUpdateImageMutationError = unknown;

/**
 * @summary 画像の名前・説明を更新（共有画像は所有者と host / admin のみ）
 */
export const useBannerGenerationControllerUpdateImage = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationControllerUpdateImage>>,
      TError,
      {
        tenantId: string;
        imageId: string;
        data: BannerGenerationUpdateImageBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerUpdateImage>>,
  TError,
  {
    tenantId: string;
    imageId: string;
    data: BannerGenerationUpdateImageBodyDto;
  },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerUpdateImageMutationOptions(options),
    queryClient
  );
};

/**
 * 共有化（tenant）は所有者のみ、共有解除（private）は所有者と host / admin が行える。権限が無い場合は 403（error=IMAGE_VISIBILITY_FORBIDDEN）。
 * @summary 画像の可視性（共有 / 非公開）を変更
 */
export const bannerGenerationControllerUpdateImageVisibility = (
  tenantId: string,
  imageId: string,
  bannerGenerationUpdateImageVisibilityBodyDto: BannerGenerationUpdateImageVisibilityBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationUpdateImageVisibilityResponseDto>(
    {
      url: `/tenants/${tenantId}/banner-generation/images/${imageId}/visibility`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationUpdateImageVisibilityBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationControllerUpdateImageVisibilityMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerGenerationControllerUpdateImageVisibility>
      >,
      TError,
      {
        tenantId: string;
        imageId: string;
        data: BannerGenerationUpdateImageVisibilityBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationControllerUpdateImageVisibility>>,
    TError,
    {
      tenantId: string;
      imageId: string;
      data: BannerGenerationUpdateImageVisibilityBodyDto;
    },
    TContext
  > => {
    const mutationKey = ["bannerGenerationControllerUpdateImageVisibility"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bannerGenerationControllerUpdateImageVisibility>
      >,
      {
        tenantId: string;
        imageId: string;
        data: BannerGenerationUpdateImageVisibilityBodyDto;
      }
    > = (props) => {
      const { tenantId, imageId, data } = props ?? {};

      return bannerGenerationControllerUpdateImageVisibility(
        tenantId,
        imageId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BannerGenerationControllerUpdateImageVisibilityMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationControllerUpdateImageVisibility>>
  >;
export type BannerGenerationControllerUpdateImageVisibilityMutationBody =
  BannerGenerationUpdateImageVisibilityBodyDto;
export type BannerGenerationControllerUpdateImageVisibilityMutationError =
  unknown;

/**
 * @summary 画像の可視性（共有 / 非公開）を変更
 */
export const useBannerGenerationControllerUpdateImageVisibility = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerGenerationControllerUpdateImageVisibility>
      >,
      TError,
      {
        tenantId: string;
        imageId: string;
        data: BannerGenerationUpdateImageVisibilityBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationControllerUpdateImageVisibility>>,
  TError,
  {
    tenantId: string;
    imageId: string;
    data: BannerGenerationUpdateImageVisibilityBodyDto;
  },
  TContext
> => {
  return useMutation(
    getBannerGenerationControllerUpdateImageVisibilityMutationOptions(options),
    queryClient
  );
};

/**
 * @summary ジョブ処理情報（プロンプト・各画像の保管パス）を取得（worker 用）
 */
export const bannerGenerationCallbackControllerGetJobDetail = (
  jobId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationJobDetailResponseDto>(
    { url: `/callback/banner-generation/jobs/${jobId}`, method: "GET", signal },
    options
  );
};

export const getBannerGenerationCallbackControllerGetJobDetailQueryKey = (
  jobId: string
) => {
  return [`/callback/banner-generation/jobs/${jobId}`] as const;
};

export const getBannerGenerationCallbackControllerGetJobDetailQueryOptions = <
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBannerGenerationCallbackControllerGetJobDetailQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>>
  > = ({ signal }) =>
    bannerGenerationCallbackControllerGetJobDetail(
      jobId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: jobId !== null && jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerGenerationCallbackControllerGetJobDetailQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>>
  >;
export type BannerGenerationCallbackControllerGetJobDetailQueryError = unknown;

export function useBannerGenerationCallbackControllerGetJobDetail<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationCallbackControllerGetJobDetail<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
          >,
          TError,
          Awaited<
            ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationCallbackControllerGetJobDetail<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ジョブ処理情報（プロンプト・各画像の保管パス）を取得（worker 用）
 */

export function useBannerGenerationCallbackControllerGetJobDetail<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerGenerationCallbackControllerGetJobDetailQueryOptions(
      jobId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ジョブ処理情報（プロンプト・各画像の保管パス）を取得（worker 用）
 */
export const prefetchBannerGenerationCallbackControllerGetJobDetailQuery =
  async <
    TData = Awaited<
      ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
    >,
    TError = unknown,
  >(
    queryClient: QueryClient,
    jobId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ): Promise<QueryClient> => {
    const queryOptions =
      getBannerGenerationCallbackControllerGetJobDetailQueryOptions(
        jobId,
        options
      );

    await queryClient.prefetchQuery(queryOptions);

    return queryClient;
  };

export const getBannerGenerationCallbackControllerGetJobDetailSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
    >,
    TError = unknown,
  >(
    jobId: string,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof connectCustomInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getBannerGenerationCallbackControllerGetJobDetailQueryKey(jobId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>>
    > = ({ signal }) =>
      bannerGenerationCallbackControllerGetJobDetail(
        jobId,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type BannerGenerationCallbackControllerGetJobDetailSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>>
  >;
export type BannerGenerationCallbackControllerGetJobDetailSuspenseQueryError =
  unknown;

export function useBannerGenerationCallbackControllerGetJobDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationCallbackControllerGetJobDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBannerGenerationCallbackControllerGetJobDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ジョブ処理情報（プロンプト・各画像の保管パス）を取得（worker 用）
 */

export function useBannerGenerationCallbackControllerGetJobDetailSuspense<
  TData = Awaited<
    ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
  >,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<typeof bannerGenerationCallbackControllerGetJobDetail>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getBannerGenerationCallbackControllerGetJobDetailSuspenseQueryOptions(
      jobId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 生成ジョブを処理中にする（worker コールバック）
 */
export const bannerGenerationCallbackControllerMarkProcessing = (
  jobId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationWorkerCallbackResponseDto>(
    {
      url: `/callback/banner-generation/jobs/${jobId}/processing`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getBannerGenerationCallbackControllerMarkProcessingMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerGenerationCallbackControllerMarkProcessing>
      >,
      TError,
      { jobId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bannerGenerationCallbackControllerMarkProcessing>
    >,
    TError,
    { jobId: string },
    TContext
  > => {
    const mutationKey = ["bannerGenerationCallbackControllerMarkProcessing"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bannerGenerationCallbackControllerMarkProcessing>
      >,
      { jobId: string }
    > = (props) => {
      const { jobId } = props ?? {};

      return bannerGenerationCallbackControllerMarkProcessing(
        jobId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BannerGenerationCallbackControllerMarkProcessingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerMarkProcessing>>
  >;

export type BannerGenerationCallbackControllerMarkProcessingMutationError =
  void;

/**
 * @summary 生成ジョブを処理中にする（worker コールバック）
 */
export const useBannerGenerationCallbackControllerMarkProcessing = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bannerGenerationCallbackControllerMarkProcessing>
      >,
      TError,
      { jobId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationCallbackControllerMarkProcessing>>,
  TError,
  { jobId: string },
  TContext
> => {
  return useMutation(
    getBannerGenerationCallbackControllerMarkProcessingMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 生成成功を確定する（worker コールバック）
 */
export const bannerGenerationCallbackControllerComplete = (
  jobId: string,
  bannerGenerationCompleteGenerationBodyDto: BannerGenerationCompleteGenerationBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationWorkerCallbackResponseDto>(
    {
      url: `/callback/banner-generation/jobs/${jobId}/complete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationCompleteGenerationBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationCallbackControllerCompleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerComplete>>,
    TError,
    { jobId: string; data: BannerGenerationCompleteGenerationBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationCallbackControllerComplete>>,
  TError,
  { jobId: string; data: BannerGenerationCompleteGenerationBodyDto },
  TContext
> => {
  const mutationKey = ["bannerGenerationCallbackControllerComplete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerComplete>>,
    { jobId: string; data: BannerGenerationCompleteGenerationBodyDto }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return bannerGenerationCallbackControllerComplete(
      jobId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationCallbackControllerCompleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerComplete>>
  >;
export type BannerGenerationCallbackControllerCompleteMutationBody =
  BannerGenerationCompleteGenerationBodyDto;
export type BannerGenerationCallbackControllerCompleteMutationError = unknown;

/**
 * @summary 生成成功を確定する（worker コールバック）
 */
export const useBannerGenerationCallbackControllerComplete = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationCallbackControllerComplete>>,
      TError,
      { jobId: string; data: BannerGenerationCompleteGenerationBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationCallbackControllerComplete>>,
  TError,
  { jobId: string; data: BannerGenerationCompleteGenerationBodyDto },
  TContext
> => {
  return useMutation(
    getBannerGenerationCallbackControllerCompleteMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 生成失敗を確定する（worker コールバック）
 */
export const bannerGenerationCallbackControllerFail = (
  jobId: string,
  bannerGenerationFailGenerationBodyDto: BannerGenerationFailGenerationBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<BannerGenerationWorkerCallbackResponseDto>(
    {
      url: `/callback/banner-generation/jobs/${jobId}/fail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bannerGenerationFailGenerationBodyDto,
      signal,
    },
    options
  );
};

export const getBannerGenerationCallbackControllerFailMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerFail>>,
    TError,
    { jobId: string; data: BannerGenerationFailGenerationBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bannerGenerationCallbackControllerFail>>,
  TError,
  { jobId: string; data: BannerGenerationFailGenerationBodyDto },
  TContext
> => {
  const mutationKey = ["bannerGenerationCallbackControllerFail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bannerGenerationCallbackControllerFail>>,
    { jobId: string; data: BannerGenerationFailGenerationBodyDto }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return bannerGenerationCallbackControllerFail(jobId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerGenerationCallbackControllerFailMutationResult = NonNullable<
  Awaited<ReturnType<typeof bannerGenerationCallbackControllerFail>>
>;
export type BannerGenerationCallbackControllerFailMutationBody =
  BannerGenerationFailGenerationBodyDto;
export type BannerGenerationCallbackControllerFailMutationError = void;

/**
 * @summary 生成失敗を確定する（worker コールバック）
 */
export const useBannerGenerationCallbackControllerFail = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bannerGenerationCallbackControllerFail>>,
      TError,
      { jobId: string; data: BannerGenerationFailGenerationBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bannerGenerationCallbackControllerFail>>,
  TError,
  { jobId: string; data: BannerGenerationFailGenerationBodyDto },
  TContext
> => {
  return useMutation(
    getBannerGenerationCallbackControllerFailMutationOptions(options),
    queryClient
  );
};

/**
 * @summary レポートのアップロード URL を発行（ホスト限定）
 */
export const reportLibraryControllerRequestReportUpload = (
  tenantId: string,
  reportLibraryRequestReportUploadBodyDto: ReportLibraryRequestReportUploadBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<ReportLibraryRequestReportUploadResponseDto>(
    {
      url: `/tenants/${tenantId}/report-library/reports/upload-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: reportLibraryRequestReportUploadBodyDto,
      signal,
    },
    options
  );
};

export const getReportLibraryControllerRequestReportUploadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportLibraryControllerRequestReportUpload>>,
    TError,
    { tenantId: string; data: ReportLibraryRequestReportUploadBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportLibraryControllerRequestReportUpload>>,
  TError,
  { tenantId: string; data: ReportLibraryRequestReportUploadBodyDto },
  TContext
> => {
  const mutationKey = ["reportLibraryControllerRequestReportUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportLibraryControllerRequestReportUpload>>,
    { tenantId: string; data: ReportLibraryRequestReportUploadBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return reportLibraryControllerRequestReportUpload(
      tenantId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportLibraryControllerRequestReportUploadMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reportLibraryControllerRequestReportUpload>>
  >;
export type ReportLibraryControllerRequestReportUploadMutationBody =
  ReportLibraryRequestReportUploadBodyDto;
export type ReportLibraryControllerRequestReportUploadMutationError = unknown;

/**
 * @summary レポートのアップロード URL を発行（ホスト限定）
 */
export const useReportLibraryControllerRequestReportUpload = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reportLibraryControllerRequestReportUpload>>,
      TError,
      { tenantId: string; data: ReportLibraryRequestReportUploadBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reportLibraryControllerRequestReportUpload>>,
  TError,
  { tenantId: string; data: ReportLibraryRequestReportUploadBodyDto },
  TContext
> => {
  return useMutation(
    getReportLibraryControllerRequestReportUploadMutationOptions(options),
    queryClient
  );
};

/**
 * @summary アップロード完了を確定しレポートを登録（ホスト限定）
 */
export const reportLibraryControllerRegisterReport = (
  tenantId: string,
  reportId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<ReportLibraryReportDto>(
    {
      url: `/tenants/${tenantId}/report-library/reports/${reportId}/register`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getReportLibraryControllerRegisterReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportLibraryControllerRegisterReport>>,
    TError,
    { tenantId: string; reportId: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportLibraryControllerRegisterReport>>,
  TError,
  { tenantId: string; reportId: string },
  TContext
> => {
  const mutationKey = ["reportLibraryControllerRegisterReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportLibraryControllerRegisterReport>>,
    { tenantId: string; reportId: string }
  > = (props) => {
    const { tenantId, reportId } = props ?? {};

    return reportLibraryControllerRegisterReport(
      tenantId,
      reportId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportLibraryControllerRegisterReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportLibraryControllerRegisterReport>>
>;

export type ReportLibraryControllerRegisterReportMutationError = unknown;

/**
 * @summary アップロード完了を確定しレポートを登録（ホスト限定）
 */
export const useReportLibraryControllerRegisterReport = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reportLibraryControllerRegisterReport>>,
      TError,
      { tenantId: string; reportId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reportLibraryControllerRegisterReport>>,
  TError,
  { tenantId: string; reportId: string },
  TContext
> => {
  return useMutation(
    getReportLibraryControllerRegisterReportMutationOptions(options),
    queryClient
  );
};

/**
 * @summary レポートの一覧・検索（ホスト以外はテナント公開のみ）
 */
export const reportLibraryControllerListReports = (
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<ReportLibraryListReportsResponseDto>(
    {
      url: `/tenants/${tenantId}/report-library/reports`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getReportLibraryControllerListReportsQueryKey = (
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams
) => {
  return [
    `/tenants/${tenantId}/report-library/reports`,
    ...(params ? [params] : []),
  ] as const;
};

export const getReportLibraryControllerListReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReportLibraryControllerListReportsQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportLibraryControllerListReports>>
  > = ({ signal }) =>
    reportLibraryControllerListReports(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportLibraryControllerListReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportLibraryControllerListReports>>
>;
export type ReportLibraryControllerListReportsQueryError = unknown;

export function useReportLibraryControllerListReports<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | ReportLibraryControllerListReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
          TError,
          Awaited<ReturnType<typeof reportLibraryControllerListReports>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerListReports<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
          TError,
          Awaited<ReturnType<typeof reportLibraryControllerListReports>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerListReports<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポートの一覧・検索（ホスト以外はテナント公開のみ）
 */

export function useReportLibraryControllerListReports<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportLibraryControllerListReportsQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary レポートの一覧・検索（ホスト以外はテナント公開のみ）
 */
export const prefetchReportLibraryControllerListReportsQuery = async <
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getReportLibraryControllerListReportsQueryOptions(
    tenantId,
    params,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getReportLibraryControllerListReportsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReportLibraryControllerListReportsQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportLibraryControllerListReports>>
  > = ({ signal }) =>
    reportLibraryControllerListReports(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportLibraryControllerListReportsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportLibraryControllerListReports>>
>;
export type ReportLibraryControllerListReportsSuspenseQueryError = unknown;

export function useReportLibraryControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | ReportLibraryControllerListReportsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポートの一覧・検索（ホスト以外はテナント公開のみ）
 */

export function useReportLibraryControllerListReportsSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
  TError = unknown,
>(
  tenantId: string,
  params?: ReportLibraryControllerListReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerListReports>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getReportLibraryControllerListReportsSuspenseQueryOptions(
      tenantId,
      params,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary レポートの取得（ホスト以外はテナント公開のみ）
 */
export const reportLibraryControllerGetReport = (
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<ReportLibraryGetReportResponseDto>(
    {
      url: `/tenants/${tenantId}/report-library/reports/${reportId}`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getReportLibraryControllerGetReportQueryKey = (
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams
) => {
  return [
    `/tenants/${tenantId}/report-library/reports/${reportId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getReportLibraryControllerGetReportQueryOptions = <
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReportLibraryControllerGetReportQueryKey(tenantId, reportId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportLibraryControllerGetReport>>
  > = ({ signal }) =>
    reportLibraryControllerGetReport(
      tenantId,
      reportId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      tenantId !== null &&
      tenantId !== undefined &&
      reportId !== null &&
      reportId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportLibraryControllerGetReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportLibraryControllerGetReport>>
>;
export type ReportLibraryControllerGetReportQueryError = unknown;

export function useReportLibraryControllerGetReport<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params: undefined | ReportLibraryControllerGetReportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
          TError,
          Awaited<ReturnType<typeof reportLibraryControllerGetReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerGetReport<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
          TError,
          Awaited<ReturnType<typeof reportLibraryControllerGetReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerGetReport<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポートの取得（ホスト以外はテナント公開のみ）
 */

export function useReportLibraryControllerGetReport<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportLibraryControllerGetReportQueryOptions(
    tenantId,
    reportId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary レポートの取得（ホスト以外はテナント公開のみ）
 */
export const prefetchReportLibraryControllerGetReportQuery = async <
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getReportLibraryControllerGetReportQueryOptions(
    tenantId,
    reportId,
    params,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getReportLibraryControllerGetReportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReportLibraryControllerGetReportQueryKey(tenantId, reportId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportLibraryControllerGetReport>>
  > = ({ signal }) =>
    reportLibraryControllerGetReport(
      tenantId,
      reportId,
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReportLibraryControllerGetReportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportLibraryControllerGetReport>>
>;
export type ReportLibraryControllerGetReportSuspenseQueryError = unknown;

export function useReportLibraryControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params: undefined | ReportLibraryControllerGetReportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReportLibraryControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary レポートの取得（ホスト以外はテナント公開のみ）
 */

export function useReportLibraryControllerGetReportSuspense<
  TData = Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
  TError = unknown,
>(
  tenantId: string,
  reportId: string,
  params?: ReportLibraryControllerGetReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof reportLibraryControllerGetReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReportLibraryControllerGetReportSuspenseQueryOptions(
    tenantId,
    reportId,
    params,
    options
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary レポートのメタ情報・可視性を更新（ホスト限定）
 */
export const reportLibraryControllerUpdateReport = (
  tenantId: string,
  reportId: string,
  reportLibraryUpdateReportBodyDto: ReportLibraryUpdateReportBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<ReportLibraryUpdateReportResponseDto>(
    {
      url: `/tenants/${tenantId}/report-library/reports/${reportId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: reportLibraryUpdateReportBodyDto,
      signal,
    },
    options
  );
};

export const getReportLibraryControllerUpdateReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportLibraryControllerUpdateReport>>,
    TError,
    {
      tenantId: string;
      reportId: string;
      data: ReportLibraryUpdateReportBodyDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportLibraryControllerUpdateReport>>,
  TError,
  {
    tenantId: string;
    reportId: string;
    data: ReportLibraryUpdateReportBodyDto;
  },
  TContext
> => {
  const mutationKey = ["reportLibraryControllerUpdateReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportLibraryControllerUpdateReport>>,
    {
      tenantId: string;
      reportId: string;
      data: ReportLibraryUpdateReportBodyDto;
    }
  > = (props) => {
    const { tenantId, reportId, data } = props ?? {};

    return reportLibraryControllerUpdateReport(
      tenantId,
      reportId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportLibraryControllerUpdateReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportLibraryControllerUpdateReport>>
>;
export type ReportLibraryControllerUpdateReportMutationBody =
  ReportLibraryUpdateReportBodyDto;
export type ReportLibraryControllerUpdateReportMutationError = unknown;

/**
 * @summary レポートのメタ情報・可視性を更新（ホスト限定）
 */
export const useReportLibraryControllerUpdateReport = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reportLibraryControllerUpdateReport>>,
      TError,
      {
        tenantId: string;
        reportId: string;
        data: ReportLibraryUpdateReportBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reportLibraryControllerUpdateReport>>,
  TError,
  {
    tenantId: string;
    reportId: string;
    data: ReportLibraryUpdateReportBodyDto;
  },
  TContext
> => {
  return useMutation(
    getReportLibraryControllerUpdateReportMutationOptions(options),
    queryClient
  );
};

/**
 * @summary レポートの削除（ホスト限定）
 */
export const reportLibraryControllerDeleteReport = (
  tenantId: string,
  reportId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<ReportLibraryDeleteReportResponseDto>(
    {
      url: `/tenants/${tenantId}/report-library/reports/${reportId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getReportLibraryControllerDeleteReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportLibraryControllerDeleteReport>>,
    TError,
    { tenantId: string; reportId: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportLibraryControllerDeleteReport>>,
  TError,
  { tenantId: string; reportId: string },
  TContext
> => {
  const mutationKey = ["reportLibraryControllerDeleteReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportLibraryControllerDeleteReport>>,
    { tenantId: string; reportId: string }
  > = (props) => {
    const { tenantId, reportId } = props ?? {};

    return reportLibraryControllerDeleteReport(
      tenantId,
      reportId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportLibraryControllerDeleteReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportLibraryControllerDeleteReport>>
>;

export type ReportLibraryControllerDeleteReportMutationError = unknown;

/**
 * @summary レポートの削除（ホスト限定）
 */
export const useReportLibraryControllerDeleteReport = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reportLibraryControllerDeleteReport>>,
      TError,
      { tenantId: string; reportId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reportLibraryControllerDeleteReport>>,
  TError,
  { tenantId: string; reportId: string },
  TContext
> => {
  return useMutation(
    getReportLibraryControllerDeleteReportMutationOptions(options),
    queryClient
  );
};

/**
 * @summary ナレッジを登録（ホスト限定）
 */
export const knowledgeLibraryControllerRegisterKnowledge = (
  tenantId: string,
  knowledgeLibraryRegisterKnowledgeBodyDto: KnowledgeLibraryRegisterKnowledgeBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<KnowledgeLibraryKnowledgeDto>(
    {
      url: `/tenants/${tenantId}/knowledge-library/knowledges`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: knowledgeLibraryRegisterKnowledgeBodyDto,
      signal,
    },
    options
  );
};

export const getKnowledgeLibraryControllerRegisterKnowledgeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof knowledgeLibraryControllerRegisterKnowledge>>,
    TError,
    { tenantId: string; data: KnowledgeLibraryRegisterKnowledgeBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof knowledgeLibraryControllerRegisterKnowledge>>,
  TError,
  { tenantId: string; data: KnowledgeLibraryRegisterKnowledgeBodyDto },
  TContext
> => {
  const mutationKey = ["knowledgeLibraryControllerRegisterKnowledge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof knowledgeLibraryControllerRegisterKnowledge>>,
    { tenantId: string; data: KnowledgeLibraryRegisterKnowledgeBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return knowledgeLibraryControllerRegisterKnowledge(
      tenantId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type KnowledgeLibraryControllerRegisterKnowledgeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof knowledgeLibraryControllerRegisterKnowledge>>
  >;
export type KnowledgeLibraryControllerRegisterKnowledgeMutationBody =
  KnowledgeLibraryRegisterKnowledgeBodyDto;
export type KnowledgeLibraryControllerRegisterKnowledgeMutationError = unknown;

/**
 * @summary ナレッジを登録（ホスト限定）
 */
export const useKnowledgeLibraryControllerRegisterKnowledge = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof knowledgeLibraryControllerRegisterKnowledge>>,
      TError,
      { tenantId: string; data: KnowledgeLibraryRegisterKnowledgeBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof knowledgeLibraryControllerRegisterKnowledge>>,
  TError,
  { tenantId: string; data: KnowledgeLibraryRegisterKnowledgeBodyDto },
  TContext
> => {
  return useMutation(
    getKnowledgeLibraryControllerRegisterKnowledgeMutationOptions(options),
    queryClient
  );
};

/**
 * @summary ナレッジの一覧・検索（ホスト限定）
 */
export const knowledgeLibraryControllerListKnowledges = (
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<KnowledgeLibraryListKnowledgesResponseDto>(
    {
      url: `/tenants/${tenantId}/knowledge-library/knowledges`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getKnowledgeLibraryControllerListKnowledgesQueryKey = (
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams
) => {
  return [
    `/tenants/${tenantId}/knowledge-library/knowledges`,
    ...(params ? [params] : []),
  ] as const;
};

export const getKnowledgeLibraryControllerListKnowledgesQueryOptions = <
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getKnowledgeLibraryControllerListKnowledgesQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>
  > = ({ signal }) =>
    knowledgeLibraryControllerListKnowledges(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type KnowledgeLibraryControllerListKnowledgesQueryResult = NonNullable<
  Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>
>;
export type KnowledgeLibraryControllerListKnowledgesQueryError = unknown;

export function useKnowledgeLibraryControllerListKnowledges<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | KnowledgeLibraryControllerListKnowledgesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
          TError,
          Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerListKnowledges<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
          TError,
          Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerListKnowledges<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ナレッジの一覧・検索（ホスト限定）
 */

export function useKnowledgeLibraryControllerListKnowledges<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getKnowledgeLibraryControllerListKnowledgesQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ナレッジの一覧・検索（ホスト限定）
 */
export const prefetchKnowledgeLibraryControllerListKnowledgesQuery = async <
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getKnowledgeLibraryControllerListKnowledgesQueryOptions(
    tenantId,
    params,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getKnowledgeLibraryControllerListKnowledgesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getKnowledgeLibraryControllerListKnowledgesQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>
  > = ({ signal }) =>
    knowledgeLibraryControllerListKnowledges(
      tenantId,
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type KnowledgeLibraryControllerListKnowledgesSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>
  >;
export type KnowledgeLibraryControllerListKnowledgesSuspenseQueryError =
  unknown;

export function useKnowledgeLibraryControllerListKnowledgesSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params: undefined | KnowledgeLibraryControllerListKnowledgesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerListKnowledgesSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerListKnowledgesSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ナレッジの一覧・検索（ホスト限定）
 */

export function useKnowledgeLibraryControllerListKnowledgesSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
  TError = unknown,
>(
  tenantId: string,
  params?: KnowledgeLibraryControllerListKnowledgesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerListKnowledges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getKnowledgeLibraryControllerListKnowledgesSuspenseQueryOptions(
      tenantId,
      params,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ナレッジの取得（本文を含む、ホスト限定）
 */
export const knowledgeLibraryControllerGetKnowledge = (
  tenantId: string,
  knowledgeId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<KnowledgeLibraryGetKnowledgeResponseDto>(
    {
      url: `/tenants/${tenantId}/knowledge-library/knowledges/${knowledgeId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getKnowledgeLibraryControllerGetKnowledgeQueryKey = (
  tenantId: string,
  knowledgeId: string
) => {
  return [
    `/tenants/${tenantId}/knowledge-library/knowledges/${knowledgeId}`,
  ] as const;
};

export const getKnowledgeLibraryControllerGetKnowledgeQueryOptions = <
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getKnowledgeLibraryControllerGetKnowledgeQueryKey(tenantId, knowledgeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>
  > = ({ signal }) =>
    knowledgeLibraryControllerGetKnowledge(
      tenantId,
      knowledgeId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      tenantId !== null &&
      tenantId !== undefined &&
      knowledgeId !== null &&
      knowledgeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type KnowledgeLibraryControllerGetKnowledgeQueryResult = NonNullable<
  Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>
>;
export type KnowledgeLibraryControllerGetKnowledgeQueryError = unknown;

export function useKnowledgeLibraryControllerGetKnowledge<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
          TError,
          Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerGetKnowledge<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
          TError,
          Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerGetKnowledge<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ナレッジの取得（本文を含む、ホスト限定）
 */

export function useKnowledgeLibraryControllerGetKnowledge<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getKnowledgeLibraryControllerGetKnowledgeQueryOptions(
    tenantId,
    knowledgeId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ナレッジの取得（本文を含む、ホスト限定）
 */
export const prefetchKnowledgeLibraryControllerGetKnowledgeQuery = async <
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getKnowledgeLibraryControllerGetKnowledgeQueryOptions(
    tenantId,
    knowledgeId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getKnowledgeLibraryControllerGetKnowledgeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getKnowledgeLibraryControllerGetKnowledgeQueryKey(tenantId, knowledgeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>
  > = ({ signal }) =>
    knowledgeLibraryControllerGetKnowledge(
      tenantId,
      knowledgeId,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type KnowledgeLibraryControllerGetKnowledgeSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>
  >;
export type KnowledgeLibraryControllerGetKnowledgeSuspenseQueryError = unknown;

export function useKnowledgeLibraryControllerGetKnowledgeSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerGetKnowledgeSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKnowledgeLibraryControllerGetKnowledgeSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ナレッジの取得（本文を含む、ホスト限定）
 */

export function useKnowledgeLibraryControllerGetKnowledgeSuspense<
  TData = Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
  TError = unknown,
>(
  tenantId: string,
  knowledgeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof knowledgeLibraryControllerGetKnowledge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getKnowledgeLibraryControllerGetKnowledgeSuspenseQueryOptions(
      tenantId,
      knowledgeId,
      options
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ナレッジの更新（ホスト限定）
 */
export const knowledgeLibraryControllerUpdateKnowledge = (
  tenantId: string,
  knowledgeId: string,
  knowledgeLibraryUpdateKnowledgeBodyDto: KnowledgeLibraryUpdateKnowledgeBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<KnowledgeLibraryKnowledgeDto>(
    {
      url: `/tenants/${tenantId}/knowledge-library/knowledges/${knowledgeId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: knowledgeLibraryUpdateKnowledgeBodyDto,
      signal,
    },
    options
  );
};

export const getKnowledgeLibraryControllerUpdateKnowledgeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof knowledgeLibraryControllerUpdateKnowledge>>,
    TError,
    {
      tenantId: string;
      knowledgeId: string;
      data: KnowledgeLibraryUpdateKnowledgeBodyDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof knowledgeLibraryControllerUpdateKnowledge>>,
  TError,
  {
    tenantId: string;
    knowledgeId: string;
    data: KnowledgeLibraryUpdateKnowledgeBodyDto;
  },
  TContext
> => {
  const mutationKey = ["knowledgeLibraryControllerUpdateKnowledge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof knowledgeLibraryControllerUpdateKnowledge>>,
    {
      tenantId: string;
      knowledgeId: string;
      data: KnowledgeLibraryUpdateKnowledgeBodyDto;
    }
  > = (props) => {
    const { tenantId, knowledgeId, data } = props ?? {};

    return knowledgeLibraryControllerUpdateKnowledge(
      tenantId,
      knowledgeId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type KnowledgeLibraryControllerUpdateKnowledgeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof knowledgeLibraryControllerUpdateKnowledge>>
  >;
export type KnowledgeLibraryControllerUpdateKnowledgeMutationBody =
  KnowledgeLibraryUpdateKnowledgeBodyDto;
export type KnowledgeLibraryControllerUpdateKnowledgeMutationError = unknown;

/**
 * @summary ナレッジの更新（ホスト限定）
 */
export const useKnowledgeLibraryControllerUpdateKnowledge = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof knowledgeLibraryControllerUpdateKnowledge>>,
      TError,
      {
        tenantId: string;
        knowledgeId: string;
        data: KnowledgeLibraryUpdateKnowledgeBodyDto;
      },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof knowledgeLibraryControllerUpdateKnowledge>>,
  TError,
  {
    tenantId: string;
    knowledgeId: string;
    data: KnowledgeLibraryUpdateKnowledgeBodyDto;
  },
  TContext
> => {
  return useMutation(
    getKnowledgeLibraryControllerUpdateKnowledgeMutationOptions(options),
    queryClient
  );
};

/**
 * @summary ナレッジの削除（ホスト限定）
 */
export const knowledgeLibraryControllerDeleteKnowledge = (
  tenantId: string,
  knowledgeId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<KnowledgeLibraryDeleteKnowledgeResponseDto>(
    {
      url: `/tenants/${tenantId}/knowledge-library/knowledges/${knowledgeId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getKnowledgeLibraryControllerDeleteKnowledgeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof knowledgeLibraryControllerDeleteKnowledge>>,
    TError,
    { tenantId: string; knowledgeId: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof knowledgeLibraryControllerDeleteKnowledge>>,
  TError,
  { tenantId: string; knowledgeId: string },
  TContext
> => {
  const mutationKey = ["knowledgeLibraryControllerDeleteKnowledge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof knowledgeLibraryControllerDeleteKnowledge>>,
    { tenantId: string; knowledgeId: string }
  > = (props) => {
    const { tenantId, knowledgeId } = props ?? {};

    return knowledgeLibraryControllerDeleteKnowledge(
      tenantId,
      knowledgeId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type KnowledgeLibraryControllerDeleteKnowledgeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof knowledgeLibraryControllerDeleteKnowledge>>
  >;

export type KnowledgeLibraryControllerDeleteKnowledgeMutationError = unknown;

/**
 * @summary ナレッジの削除（ホスト限定）
 */
export const useKnowledgeLibraryControllerDeleteKnowledge = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof knowledgeLibraryControllerDeleteKnowledge>>,
      TError,
      { tenantId: string; knowledgeId: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof knowledgeLibraryControllerDeleteKnowledge>>,
  TError,
  { tenantId: string; knowledgeId: string },
  TContext
> => {
  return useMutation(
    getKnowledgeLibraryControllerDeleteKnowledgeMutationOptions(options),
    queryClient
  );
};

/**
 * @summary テナントを作成（ホスト限定）
 */
export const tenantsControllerCreateTenant = (
  tenantsCreateTenantBodyDto: TenantsCreateTenantBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<TenantsTenantDto>(
    {
      url: `/tenants`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: tenantsCreateTenantBodyDto,
      signal,
    },
    options
  );
};

export const getTenantsControllerCreateTenantMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantsControllerCreateTenant>>,
    TError,
    { data: TenantsCreateTenantBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantsControllerCreateTenant>>,
  TError,
  { data: TenantsCreateTenantBodyDto },
  TContext
> => {
  const mutationKey = ["tenantsControllerCreateTenant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantsControllerCreateTenant>>,
    { data: TenantsCreateTenantBodyDto }
  > = (props) => {
    const { data } = props ?? {};

    return tenantsControllerCreateTenant(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantsControllerCreateTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantsControllerCreateTenant>>
>;
export type TenantsControllerCreateTenantMutationBody =
  TenantsCreateTenantBodyDto;
export type TenantsControllerCreateTenantMutationError = unknown;

/**
 * @summary テナントを作成（ホスト限定）
 */
export const useTenantsControllerCreateTenant = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantsControllerCreateTenant>>,
      TError,
      { data: TenantsCreateTenantBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantsControllerCreateTenant>>,
  TError,
  { data: TenantsCreateTenantBodyDto },
  TContext
> => {
  return useMutation(
    getTenantsControllerCreateTenantMutationOptions(options),
    queryClient
  );
};

/**
 * @summary テナント一覧（ホスト限定。残クレジット・ユーザー数を含む）
 */
export const tenantsControllerListTenants = (
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<TenantsListTenantsResponseDto>(
    { url: `/tenants`, method: "GET", signal },
    options
  );
};

export const getTenantsControllerListTenantsQueryKey = () => {
  return [`/tenants`] as const;
};

export const getTenantsControllerListTenantsQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantsControllerListTenants>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantsControllerListTenantsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantsControllerListTenants>>
  > = ({ signal }) => tenantsControllerListTenants(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantsControllerListTenants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantsControllerListTenantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantsControllerListTenants>>
>;
export type TenantsControllerListTenantsQueryError = unknown;

export function useTenantsControllerListTenants<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsControllerListTenants>>,
          TError,
          Awaited<ReturnType<typeof tenantsControllerListTenants>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerListTenants<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsControllerListTenants>>,
          TError,
          Awaited<ReturnType<typeof tenantsControllerListTenants>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerListTenants<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary テナント一覧（ホスト限定。残クレジット・ユーザー数を含む）
 */

export function useTenantsControllerListTenants<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTenantsControllerListTenantsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary テナント一覧（ホスト限定。残クレジット・ユーザー数を含む）
 */
export const prefetchTenantsControllerListTenantsQuery = async <
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getTenantsControllerListTenantsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getTenantsControllerListTenantsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof tenantsControllerListTenants>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantsControllerListTenantsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantsControllerListTenants>>
  > = ({ signal }) => tenantsControllerListTenants(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof tenantsControllerListTenants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantsControllerListTenantsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantsControllerListTenants>>
>;
export type TenantsControllerListTenantsSuspenseQueryError = unknown;

export function useTenantsControllerListTenantsSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerListTenantsSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerListTenantsSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary テナント一覧（ホスト限定。残クレジット・ユーザー数を含む）
 */

export function useTenantsControllerListTenantsSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerListTenants>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerListTenants>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getTenantsControllerListTenantsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary テナント詳細（ホストまたは自テナントのユーザー）
 */
export const tenantsControllerGetTenant = (
  tenantId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<TenantsTenantDto>(
    { url: `/tenants/${tenantId}`, method: "GET", signal },
    options
  );
};

export const getTenantsControllerGetTenantQueryKey = (tenantId: string) => {
  return [`/tenants/${tenantId}`] as const;
};

export const getTenantsControllerGetTenantQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantsControllerGetTenantQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantsControllerGetTenant>>
  > = ({ signal }) =>
    tenantsControllerGetTenant(tenantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantsControllerGetTenantQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantsControllerGetTenant>>
>;
export type TenantsControllerGetTenantQueryError = unknown;

export function useTenantsControllerGetTenant<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
          TError,
          Awaited<ReturnType<typeof tenantsControllerGetTenant>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerGetTenant<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
          TError,
          Awaited<ReturnType<typeof tenantsControllerGetTenant>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerGetTenant<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary テナント詳細（ホストまたは自テナントのユーザー）
 */

export function useTenantsControllerGetTenant<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTenantsControllerGetTenantQueryOptions(
    tenantId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary テナント詳細（ホストまたは自テナントのユーザー）
 */
export const prefetchTenantsControllerGetTenantQuery = async <
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getTenantsControllerGetTenantQueryOptions(
    tenantId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getTenantsControllerGetTenantSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantsControllerGetTenantQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantsControllerGetTenant>>
  > = ({ signal }) =>
    tenantsControllerGetTenant(tenantId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TenantsControllerGetTenantSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantsControllerGetTenant>>
>;
export type TenantsControllerGetTenantSuspenseQueryError = unknown;

export function useTenantsControllerGetTenantSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerGetTenantSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTenantsControllerGetTenantSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary テナント詳細（ホストまたは自テナントのユーザー）
 */

export function useTenantsControllerGetTenantSuspense<
  TData = Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof tenantsControllerGetTenant>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTenantsControllerGetTenantSuspenseQueryOptions(
    tenantId,
    options
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary テナントを更新（ホスト限定）
 */
export const tenantsControllerUpdateTenant = (
  tenantId: string,
  tenantsUpdateTenantBodyDto: TenantsUpdateTenantBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<TenantsTenantDto>(
    {
      url: `/tenants/${tenantId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: tenantsUpdateTenantBodyDto,
      signal,
    },
    options
  );
};

export const getTenantsControllerUpdateTenantMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantsControllerUpdateTenant>>,
    TError,
    { tenantId: string; data: TenantsUpdateTenantBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantsControllerUpdateTenant>>,
  TError,
  { tenantId: string; data: TenantsUpdateTenantBodyDto },
  TContext
> => {
  const mutationKey = ["tenantsControllerUpdateTenant"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantsControllerUpdateTenant>>,
    { tenantId: string; data: TenantsUpdateTenantBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return tenantsControllerUpdateTenant(tenantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantsControllerUpdateTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantsControllerUpdateTenant>>
>;
export type TenantsControllerUpdateTenantMutationBody =
  TenantsUpdateTenantBodyDto;
export type TenantsControllerUpdateTenantMutationError = unknown;

/**
 * @summary テナントを更新（ホスト限定）
 */
export const useTenantsControllerUpdateTenant = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tenantsControllerUpdateTenant>>,
      TError,
      { tenantId: string; data: TenantsUpdateTenantBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof tenantsControllerUpdateTenant>>,
  TError,
  { tenantId: string; data: TenantsUpdateTenantBodyDto },
  TContext
> => {
  return useMutation(
    getTenantsControllerUpdateTenantMutationOptions(options),
    queryClient
  );
};

/**
 * @summary テナントのユーザー一覧（ホスト・管理者）
 */
export const usersControllerListUsers = (
  tenantId: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<UsersListUsersResponseDto>(
    { url: `/tenants/${tenantId}/users`, method: "GET", signal },
    options
  );
};

export const getUsersControllerListUsersQueryKey = (tenantId: string) => {
  return [`/tenants/${tenantId}/users`] as const;
};

export const getUsersControllerListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUsersControllerListUsersQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersControllerListUsers>>
  > = ({ signal }) =>
    usersControllerListUsers(tenantId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: tenantId !== null && tenantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof usersControllerListUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersControllerListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerListUsers>>
>;
export type UsersControllerListUsersQueryError = unknown;

export function useUsersControllerListUsers<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerListUsers>>,
          TError,
          Awaited<ReturnType<typeof usersControllerListUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersControllerListUsers<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersControllerListUsers>>,
          TError,
          Awaited<ReturnType<typeof usersControllerListUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersControllerListUsers<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary テナントのユーザー一覧（ホスト・管理者）
 */

export function useUsersControllerListUsers<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUsersControllerListUsersQueryOptions(
    tenantId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary テナントのユーザー一覧（ホスト・管理者）
 */
export const prefetchUsersControllerListUsersQuery = async <
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getUsersControllerListUsersQueryOptions(
    tenantId,
    options
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getUsersControllerListUsersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUsersControllerListUsersQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersControllerListUsers>>
  > = ({ signal }) =>
    usersControllerListUsers(tenantId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof usersControllerListUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersControllerListUsersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerListUsers>>
>;
export type UsersControllerListUsersSuspenseQueryError = unknown;

export function useUsersControllerListUsersSuspense<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersControllerListUsersSuspense<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUsersControllerListUsersSuspense<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary テナントのユーザー一覧（ホスト・管理者）
 */

export function useUsersControllerListUsersSuspense<
  TData = Awaited<ReturnType<typeof usersControllerListUsers>>,
  TError = unknown,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof usersControllerListUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUsersControllerListUsersSuspenseQueryOptions(
    tenantId,
    options
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary ユーザーを招待（ホスト・管理者。上限超過は 409）
 */
export const usersControllerInviteUser = (
  tenantId: string,
  usersInviteUserBodyDto: UsersInviteUserBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<UsersUserDto>(
    {
      url: `/tenants/${tenantId}/users/invitations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: usersInviteUserBodyDto,
      signal,
    },
    options
  );
};

export const getUsersControllerInviteUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerInviteUser>>,
    TError,
    { tenantId: string; data: UsersInviteUserBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerInviteUser>>,
  TError,
  { tenantId: string; data: UsersInviteUserBodyDto },
  TContext
> => {
  const mutationKey = ["usersControllerInviteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerInviteUser>>,
    { tenantId: string; data: UsersInviteUserBodyDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return usersControllerInviteUser(tenantId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerInviteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerInviteUser>>
>;
export type UsersControllerInviteUserMutationBody = UsersInviteUserBodyDto;
export type UsersControllerInviteUserMutationError = unknown;

/**
 * @summary ユーザーを招待（ホスト・管理者。上限超過は 409）
 */
export const useUsersControllerInviteUser = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerInviteUser>>,
      TError,
      { tenantId: string; data: UsersInviteUserBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerInviteUser>>,
  TError,
  { tenantId: string; data: UsersInviteUserBodyDto },
  TContext
> => {
  return useMutation(
    getUsersControllerInviteUserMutationOptions(options),
    queryClient
  );
};

/**
 * authorizer の結果は 1 分キャッシュされるため、対象ユーザーの権限に反映されるまで最大 1 分かかる。
 * @summary ユーザーのロールを変更（ホスト・管理者。自分自身は不可。最後の管理者の降格は 409）
 */
export const usersControllerUpdateUserRole = (
  tenantId: string,
  sub: string,
  usersUpdateUserRoleBodyDto: UsersUpdateUserRoleBodyDto,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<UsersUserDto>(
    {
      url: `/tenants/${tenantId}/users/${sub}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: usersUpdateUserRoleBodyDto,
      signal,
    },
    options
  );
};

export const getUsersControllerUpdateUserRoleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerUpdateUserRole>>,
    TError,
    { tenantId: string; sub: string; data: UsersUpdateUserRoleBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerUpdateUserRole>>,
  TError,
  { tenantId: string; sub: string; data: UsersUpdateUserRoleBodyDto },
  TContext
> => {
  const mutationKey = ["usersControllerUpdateUserRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerUpdateUserRole>>,
    { tenantId: string; sub: string; data: UsersUpdateUserRoleBodyDto }
  > = (props) => {
    const { tenantId, sub, data } = props ?? {};

    return usersControllerUpdateUserRole(tenantId, sub, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerUpdateUserRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerUpdateUserRole>>
>;
export type UsersControllerUpdateUserRoleMutationBody =
  UsersUpdateUserRoleBodyDto;
export type UsersControllerUpdateUserRoleMutationError = unknown;

/**
 * @summary ユーザーのロールを変更（ホスト・管理者。自分自身は不可。最後の管理者の降格は 409）
 */
export const useUsersControllerUpdateUserRole = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerUpdateUserRole>>,
      TError,
      { tenantId: string; sub: string; data: UsersUpdateUserRoleBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerUpdateUserRole>>,
  TError,
  { tenantId: string; sub: string; data: UsersUpdateUserRoleBodyDto },
  TContext
> => {
  return useMutation(
    getUsersControllerUpdateUserRoleMutationOptions(options),
    queryClient
  );
};

/**
 * @summary ユーザーを削除（ホスト・管理者。自分自身は不可。最後の管理者は 409）
 */
export const usersControllerDeleteUser = (
  tenantId: string,
  sub: string,
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<void>(
    { url: `/tenants/${tenantId}/users/${sub}`, method: "DELETE", signal },
    options
  );
};

export const getUsersControllerDeleteUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerDeleteUser>>,
    TError,
    { tenantId: string; sub: string },
    TContext
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerDeleteUser>>,
  TError,
  { tenantId: string; sub: string },
  TContext
> => {
  const mutationKey = ["usersControllerDeleteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerDeleteUser>>,
    { tenantId: string; sub: string }
  > = (props) => {
    const { tenantId, sub } = props ?? {};

    return usersControllerDeleteUser(tenantId, sub, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerDeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerDeleteUser>>
>;

export type UsersControllerDeleteUserMutationError = unknown;

/**
 * @summary ユーザーを削除（ホスト・管理者。自分自身は不可。最後の管理者は 409）
 */
export const useUsersControllerDeleteUser = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof usersControllerDeleteUser>>,
      TError,
      { tenantId: string; sub: string },
      TContext
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerDeleteUser>>,
  TError,
  { tenantId: string; sub: string },
  TContext
> => {
  return useMutation(
    getUsersControllerDeleteUserMutationOptions(options),
    queryClient
  );
};

/**
 * @summary 認証ユーザー自身のロールと所属テナントを取得
 */
export const whoamiControllerGetWhoami = (
  options?: SecondParameter<typeof connectCustomInstance>,
  signal?: AbortSignal
) => {
  return connectCustomInstance<WhoamiResponseDto>(
    { url: `/whoami`, method: "GET", signal },
    options
  );
};

export const getWhoamiControllerGetWhoamiQueryKey = () => {
  return [`/whoami`] as const;
};

export const getWhoamiControllerGetWhoamiQueryOptions = <
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWhoamiControllerGetWhoamiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof whoamiControllerGetWhoami>>
  > = ({ signal }) => whoamiControllerGetWhoami(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WhoamiControllerGetWhoamiQueryResult = NonNullable<
  Awaited<ReturnType<typeof whoamiControllerGetWhoami>>
>;
export type WhoamiControllerGetWhoamiQueryError = unknown;

export function useWhoamiControllerGetWhoami<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
          TError,
          Awaited<ReturnType<typeof whoamiControllerGetWhoami>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhoamiControllerGetWhoami<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
          TError,
          Awaited<ReturnType<typeof whoamiControllerGetWhoami>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhoamiControllerGetWhoami<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 認証ユーザー自身のロールと所属テナントを取得
 */

export function useWhoamiControllerGetWhoami<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWhoamiControllerGetWhoamiQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 認証ユーザー自身のロールと所属テナントを取得
 */
export const prefetchWhoamiControllerGetWhoamiQuery = async <
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getWhoamiControllerGetWhoamiQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getWhoamiControllerGetWhoamiSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof connectCustomInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWhoamiControllerGetWhoamiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof whoamiControllerGetWhoami>>
  > = ({ signal }) => whoamiControllerGetWhoami(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WhoamiControllerGetWhoamiSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof whoamiControllerGetWhoami>>
>;
export type WhoamiControllerGetWhoamiSuspenseQueryError = unknown;

export function useWhoamiControllerGetWhoamiSuspense<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhoamiControllerGetWhoamiSuspense<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWhoamiControllerGetWhoamiSuspense<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 認証ユーザー自身のロールと所属テナントを取得
 */

export function useWhoamiControllerGetWhoamiSuspense<
  TData = Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof whoamiControllerGetWhoami>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof connectCustomInstance>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getWhoamiControllerGetWhoamiSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
